// import React, { useState } from "react";
// import {
//   Box,
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   TextField,
//   Chip,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   List,
//   ListItem,
//   ListItemText,
//   InputAdornment,
//   Tabs,
//   Tab
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import SearchIcon from "@mui/icons-material/Search";
// import AddIcon from "@mui/icons-material/Add";
// import CloseIcon from "@mui/icons-material/Close";
// import { useNavigate } from "react-router-dom";
// import { popularCities, propertyTypes, tabs as filterTabs } from "./propertyFilters";

// const PropertySearchFilters = () => {
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedLocations, setSelectedLocations] = useState([]);
//   const [useCurrentLocation, setUseCurrentLocation] = useState(false);
//   const [propertyTypeDialogOpen, setPropertyTypeDialogOpen] = useState(false);
//   const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
//   const [locationDialogOpen, setLocationDialogOpen] = useState(false);
//   const [activeTab, setActiveTab] = useState(0);

//   const colors = {
//     primary: "#1a1a1a",
//     secondary: "#8B7355",
//     background: "#f5f5f5"
//   };

//   const handleLocationSelect = (location) => {
//     if (selectedLocations.length < 3 && !selectedLocations.includes(location)) {
//       setSelectedLocations([...selectedLocations, location]);
//     }
//   };

//   const handleLocationRemove = (locationToRemove) => {
//     setSelectedLocations(selectedLocations.filter(location => location !== locationToRemove));
//   };

//   const handlePropertyTypeSelect = (type) => {
//     if (selectedPropertyTypes.includes(type)) {
//       setSelectedPropertyTypes(selectedPropertyTypes.filter(t => t !== type));
//     } else {
//       setSelectedPropertyTypes([...selectedPropertyTypes, type]);
//     }
//   };

//   const handleUseCurrentLocation = () => {
//     setUseCurrentLocation(!useCurrentLocation);
//     if (!useCurrentLocation) {
//       // Simulate getting current location
//       setSelectedLocations([...selectedLocations, "My Current Location"]);
//     } else {
//       setSelectedLocations(selectedLocations.filter(loc => loc !== "My Current Location"));
//     }
//   };

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

//   const handleApplyFilters = () => {
//     // Navigate to results page with filter parameters
//     navigate('/property-results', {
//       state: {
//         filters: {
//           searchQuery,
//           selectedLocations,
//           selectedPropertyTypes,
//           useCurrentLocation,
//           activeTab: activeTab // Pass the selected tab to results
//         }
//       }
//     });
//   };

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background }}>
//       {/* Header */}
//       <AppBar position="sticky" sx={{ backgroundColor: colors.primary, color: "#fff" }}>
//         <Toolbar>
//           <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography variant="h6" sx={{ ml: 2 }}>Property Search</Typography>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 2, flex: 1 }}>
//         {/* Search Box */}
//         <TextField
//           fullWidth
//           variant="outlined"
//           placeholder="Search upto 3 localities or landmarks"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: colors.secondary }} />
//               </InputAdornment>
//             )
//           }}
//           sx={{
//             mb: 3,
//             '& .MuiOutlinedInput-root': {
//               borderRadius: 2,
//               backgroundColor: '#fff',
//               '&:hover fieldset': { borderColor: colors.secondary }
//             }
//           }}
//         />

//         {/* Use Current Location */}
//         <FormControlLabel
//           control={
//             <Checkbox
//               checked={useCurrentLocation}
//               onChange={handleUseCurrentLocation}
//               sx={{ color: colors.secondary }}
//             />
//           }
//           label="Use my current location"
//           sx={{ mb: 3 }}
//         />

//         {/* Add Locations Section */}
//         <Box sx={{ mb: 3 }}>
//           <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
//             Add Locations
//           </Typography>
          
//           {/* Selected Locations Chips */}
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
//             {selectedLocations.map((location, index) => (
//               <Chip
//                 key={index}
//                 label={`+ ${location}`}
//                 onDelete={() => handleLocationRemove(location)}
//                 sx={{
//                   backgroundColor: colors.secondary,
//                   color: "#fff",
//                   fontWeight: 'bold',
//                   '& .MuiChip-deleteIcon': {
//                     color: "#fff"
//                   }
//                 }}
//               />
//             ))}
//             {selectedLocations.length < 3 && (
//               <Chip
//                 label="Add Location"
//                 onClick={() => setLocationDialogOpen(true)}
//                 variant="outlined"
//                 deleteIcon={<AddIcon />}
//                 onDelete={() => setLocationDialogOpen(true)}
//                 sx={{
//                   borderColor: colors.secondary,
//                   color: colors.secondary,
//                   '& .MuiChip-deleteIcon': {
//                     color: colors.secondary
//                   }
//                 }}
//               />
//             )}
//           </Box>

//           {/* Popular Cities */}
//           <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
//             Popular cities in India
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//             {popularCities.map((city, index) => (
//               <Chip
//                 key={index}
//                 label={`+${city}`}
//                 onClick={() => handleLocationSelect(city)}
//                 variant="outlined"
//                 sx={{
//                   borderColor: colors.secondary,
//                   color: colors.secondary,
//                   fontWeight: 'bold',
//                   '&:hover': {
//                     backgroundColor: colors.secondary,
//                     color: "#fff"
//                   }
//                 }}
//               />
//             ))}
//           </Box>
//         </Box>

//         {/* Property Type Filter */}
//         <Box sx={{ mb: 3 }}>
//           <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
//             Plot/ Building
//           </Typography>
//           <Chip
//             label={selectedPropertyTypes.length > 0 ? `${selectedPropertyTypes.length} selected` : "Select Property Types"}
//             onClick={() => setPropertyTypeDialogOpen(true)}
//             variant="outlined"
//             deleteIcon={<AddIcon />}
//             onDelete={() => setPropertyTypeDialogOpen(true)}
//             sx={{
//               borderColor: colors.secondary,
//               color: colors.secondary,
//               '& .MuiChip-deleteIcon': {
//                 color: colors.secondary
//               }
//             }}
//           />
//           {selectedPropertyTypes.length > 0 && (
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
//               {selectedPropertyTypes.map((type, index) => (
//                 <Chip
//                   key={index}
//                   label={type}
//                   onDelete={() => handlePropertyTypeSelect(type)}
//                   sx={{
//                     backgroundColor: colors.secondary,
//                     color: "#fff",
//                     '& .MuiChip-deleteIcon': {
//                       color: "#fff"
//                     }
//                   }}
//                 />
//               ))}
//             </Box>
//           )}
//         </Box>

//         {/* Tabs Section - Added after Plot/Building */}
//         <Box sx={{ mb: 4, backgroundColor: '#fff', borderRadius: 2, overflow: 'hidden', border: '1px solid #e0e0e0' }}>
//           <Typography variant="h6" sx={{ p: 2, fontWeight: 'bold', color: colors.primary, borderBottom: '1px solid #e0e0e0' }}>
//             Looking For
//           </Typography>
//           <Tabs 
//             value={activeTab} 
//             onChange={handleTabChange} 
//             variant="scrollable" 
//             scrollButtons="auto"
//             sx={{ 
//               '& .MuiTab-root': { 
//                 fontSize: '0.8rem', 
//                 fontWeight: 'bold', 
//                 color: colors.primary, 
//                 minWidth: 'auto', 
//                 px: 2, 
//                 py: 1.5,
//                 '&.Mui-selected': { color: colors.secondary } 
//               }, 
//               '& .MuiTabs-indicator': { backgroundColor: colors.secondary } 
//             }}
//           >
//             {filterTabs.map((tab, index) => (
//               <Tab key={index} label={tab.label} />
//             ))}
//           </Tabs>
//           <Box sx={{ p: 2, backgroundColor: '#f9f9f9', borderTop: '1px solid #e0e0e0' }}>
//             <Typography variant="body2" sx={{ color: colors.primary, fontStyle: 'italic' }}>
//               Selected: <strong>{filterTabs[activeTab]?.label || "None"}</strong>
//             </Typography>
//           </Box>
//         </Box>

//         {/* Apply Button */}
//         <Button
//           variant="contained"
//           fullWidth
//           onClick={handleApplyFilters}
//           sx={{
//             backgroundColor: colors.secondary,
//             color: "#fff",
//             py: 1.5,
//             fontSize: '1rem',
//             fontWeight: 'bold',
//             borderRadius: 2,
//             '&:hover': {
//               backgroundColor: "#A52A2A"
//             }
//           }}
//         >
//           Apply
//         </Button>
//       </Box>

//       {/* Location Dialog */}
//       <Dialog open={locationDialogOpen} onClose={() => setLocationDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Add Locations</Typography>
//             <IconButton onClick={() => setLocationDialogOpen(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={useCurrentLocation}
//                 onChange={handleUseCurrentLocation}
//                 sx={{ color: colors.secondary }}
//               />
//             }
//             label="Use my current location"
//           />
//           <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
//             Selected Locations
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
//             {selectedLocations.map((location, index) => (
//               <Chip
//                 key={index}
//                 label={`+ ${location}`}
//                 onDelete={() => handleLocationRemove(location)}
//                 sx={{
//                   backgroundColor: colors.secondary,
//                   color: "#fff",
//                   '& .MuiChip-deleteIcon': {
//                     color: "#fff"
//                   }
//                 }}
//               />
//             ))}
//           </Box>
//           <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
//             Popular cities in India
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//             {popularCities.map((city, index) => (
//               <Chip
//                 key={index}
//                 label={`+${city}`}
//                 onClick={() => handleLocationSelect(city)}
//                 variant="outlined"
//                 sx={{
//                   borderColor: colors.secondary,
//                   color: colors.secondary,
//                   '&:hover': {
//                     backgroundColor: colors.secondary,
//                     color: "#fff"
//                   }
//                 }}
//               />
//             ))}
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button
//             onClick={() => setLocationDialogOpen(false)}
//             variant="contained"
//             fullWidth
//             sx={{
//               backgroundColor: colors.secondary,
//               color: "#fff",
//               '&:hover': { backgroundColor: "#A52A2A" }
//             }}
//           >
//             Done
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Property Type Dialog */}
//       <Dialog open={propertyTypeDialogOpen} onClose={() => setPropertyTypeDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Select Property Type</Typography>
//             <IconButton onClick={() => setPropertyTypeDialogOpen(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <List>
//             {propertyTypes.map((type, index) => (
//               <ListItem
//                 key={index}
//                 button
//                 onClick={() => handlePropertyTypeSelect(type)}
//                 sx={{
//                   borderBottom: '1px solid #e0e0e0',
//                   '&:last-child': { borderBottom: 'none' }
//                 }}
//               >
//                 <Checkbox
//                   checked={selectedPropertyTypes.includes(type)}
//                   sx={{ color: colors.secondary }}
//                 />
//                 <ListItemText primary={type} />
//               </ListItem>
//             ))}
//           </List>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button
//             onClick={() => setPropertyTypeDialogOpen(false)}
//             variant="contained"
//             fullWidth
//             sx={{
//               backgroundColor: colors.secondary,
//               color: "#fff",
//               '&:hover': { backgroundColor: "#A52A2A" }
//             }}
//           >
//             Done
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default PropertySearchFilters;


// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   TextField,
//   Chip,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   InputAdornment,
//   Tabs,
//   Tab,
//   Paper,
//   Divider,
//   CircularProgress
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import SearchIcon from "@mui/icons-material/Search";
// import AddIcon from "@mui/icons-material/Add";
// import CloseIcon from "@mui/icons-material/Close";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import ApartmentIcon from "@mui/icons-material/Apartment";
// import HomeWorkIcon from "@mui/icons-material/HomeWork";
// import { useNavigate } from "react-router-dom";
// import { popularCities, propertyTypes, tabs as filterTabs } from "./propertyFilters";

// // Mock search results data - In a real app, this would come from an API
// const mockSearchResults = {
//   "Rajanna": [
//     { type: "city", name: "Rajanna Sireilla", location: "City", count: 21 },
//     { type: "locality", name: "Rajanna Layout, Horamavu", location: "Locality", count: 17 },
//     { type: "locality", name: "Rajanna Bowli, Aliabad, Hyderabad", location: "Locality", count: 0 },
//     { type: "project", name: "Rajanna Layout, Gundlupet, Chamarajanagar", location: "Project", count: 0 },
//     { type: "locality", name: "Rajanna Colony, Old Airport Road", location: "Locality", count: 0 },
//     { type: "project", name: "Rajanna Pearl Apartment, Rabindrapalli, Kolkata", location: "Project", count: 0 },
//     { type: "project", name: "Gupta Rajanna Nagar, Pangra, Nizamabad", location: "Project", count: 0 },
//     { type: "project", name: "Garapati Rajanna Towers, Nidadavole, West Godavari", location: "Project", count: 0 },
//     { type: "project", name: "N Rajanna Nilaya, S.G. Palya, Bangalore", location: "Project", count: 0 },
//     { type: "project", name: "Sri Garapati Rajanna Heights, Nidadavole, West Godavari", location: "Project", count: 0 },
//     { type: "locality", name: "Sireilla, Rajanna Sireilla", location: "Locality", count: 5 },
//     { type: "locality", name: "Vemulawada, Rajanna Sireilla", location: "Locality", count: 7 },
//     { type: "locality", name: "Yellareddypet, Rajanna Sireilla", location: "Locality", count: 1 },
//     { type: "locality", name: "Thangallapalli, Rajanna Sireilla", location: "Locality", count: 1 },
//     { type: "locality", name: "Narsingapur, Rajanna Sireilla", location: "Locality", count: 0 }
//   ]
// };

// const PropertySearchFilters = () => {
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedLocations, setSelectedLocations] = useState([]);
//   const [useCurrentLocation, setUseCurrentLocation] = useState(false);
//   const [propertyTypeDialogOpen, setPropertyTypeDialogOpen] = useState(false);
//   const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
//   const [locationDialogOpen, setLocationDialogOpen] = useState(false);
//   const [activeTab, setActiveTab] = useState(0);
//   const [searchResults, setSearchResults] = useState([]);
//   const [showSearchResults, setShowSearchResults] = useState(false);
//   const [isSearching, setIsSearching] = useState(false);

//   const colors = {
//     primary: "#1a1a1a",
//     secondary: "#8B7355",
//     background: "#f5f5f5"
//   };

//   // Debounced search effect
//   useEffect(() => {
//     if (searchQuery.trim() === "") {
//       setSearchResults([]);
//       setShowSearchResults(false);
//       return;
//     }

//     setIsSearching(true);
//     const timer = setTimeout(() => {
//       // Mock API call - replace with actual API call
//       const query = searchQuery.toLowerCase();
//       const results = mockSearchResults["Rajanna"] || [];
      
//       // Filter results based on search query
//       const filteredResults = results.filter(item => 
//         item.name.toLowerCase().includes(query)
//       );
      
//       setSearchResults(filteredResults);
//       setShowSearchResults(true);
//       setIsSearching(false);
//     }, 300);

//     return () => clearTimeout(timer);
//   }, [searchQuery]);

//   const handleLocationSelect = (location) => {
//     if (selectedLocations.length < 3 && !selectedLocations.includes(location)) {
//       setSelectedLocations([...selectedLocations, location]);
//       setSearchQuery("");
//       setShowSearchResults(false);
//     }
//   };

//   const handleLocationRemove = (locationToRemove) => {
//     setSelectedLocations(selectedLocations.filter(location => location !== locationToRemove));
//   };

//   const handlePropertyTypeSelect = (type) => {
//     if (selectedPropertyTypes.includes(type)) {
//       setSelectedPropertyTypes(selectedPropertyTypes.filter(t => t !== type));
//     } else {
//       setSelectedPropertyTypes([...selectedPropertyTypes, type]);
//     }
//   };

//   const handleUseCurrentLocation = () => {
//     setUseCurrentLocation(!useCurrentLocation);
//     if (!useCurrentLocation) {
//       // Simulate getting current location
//       setSelectedLocations([...selectedLocations, "My Current Location"]);
//     } else {
//       setSelectedLocations(selectedLocations.filter(loc => loc !== "My Current Location"));
//     }
//   };

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

//   const handleApplyFilters = () => {
//     // Navigate to results page with filter parameters
//     navigate('/property-results', {
//       state: {
//         filters: {
//           searchQuery,
//           selectedLocations,
//           selectedPropertyTypes,
//           useCurrentLocation,
//           activeTab: activeTab // Pass the selected tab to results
//         }
//       }
//     });
//   };

//   const handleSearchResultClick = (result) => {
//     handleLocationSelect(result.name);
//   };

//   const getLocationIcon = (type) => {
//     switch (type) {
//       case "city":
//         return <LocationOnIcon sx={{ color: colors.secondary }} />;
//       case "locality":
//         return <HomeWorkIcon sx={{ color: colors.secondary }} />;
//       case "project":
//         return <ApartmentIcon sx={{ color: colors.secondary }} />;
//       default:
//         return <LocationOnIcon sx={{ color: colors.secondary }} />;
//     }
//   };

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background, position: "relative" }}>
//       {/* Header */}
//       <AppBar position="sticky" sx={{ backgroundColor: colors.primary, color: "#fff" }}>
//         <Toolbar>
//           <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography variant="h6" sx={{ ml: 2 }}>Property Search</Typography>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 2, flex: 1 }}>
//         {/* Search Box */}
//         <Box sx={{ position: "relative", mb: 3 }}>
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder="Search upto 3 localities or landmarks"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon sx={{ color: colors.secondary }} />
//                 </InputAdornment>
//               ),
//               endAdornment: isSearching ? (
//                 <InputAdornment position="end">
//                   <CircularProgress size={20} />
//                 </InputAdornment>
//               ) : null
//             }}
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 2,
//                 backgroundColor: '#fff',
//                 '&:hover fieldset': { borderColor: colors.secondary },
//                 '&.Mui-focused fieldset': { borderColor: colors.secondary }
//               }
//             }}
//             onFocus={() => {
//               if (searchQuery.trim() !== "") {
//                 setShowSearchResults(true);
//               }
//             }}
//           />

//           {/* Search Results Dropdown */}
//           {showSearchResults && searchResults.length > 0 && (
//             <Paper
//               elevation={3}
//               sx={{
//                 position: "absolute",
//                 top: "100%",
//                 left: 0,
//                 right: 0,
//                 zIndex: 1300,
//                 mt: 1,
//                 maxHeight: 400,
//                 overflow: "auto",
//                 border: `1px solid ${colors.secondary}`
//               }}
//             >
//               <List dense sx={{ py: 0 }}>
//                 {searchResults.map((result, index) => (
//                   <React.Fragment key={index}>
//                     <ListItem
//                       button
//                       onClick={() => handleSearchResultClick(result)}
//                       sx={{
//                         py: 1.5,
//                         '&:hover': {
//                           backgroundColor: "rgba(139, 115, 85, 0.1)"
//                         }
//                       }}
//                     >
//                       <ListItemIcon>
//                         {getLocationIcon(result.type)}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={
//                           <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
//                             {result.name}
//                           </Typography>
//                         }
//                         secondary={
//                           <Typography variant="caption" sx={{ color: 'text.secondary' }}>
//                             {result.location}
//                           </Typography>
//                         }
//                       />
//                       {result.count > 0 && (
//                         <Chip
//                           label={result.count}
//                           size="small"
//                           sx={{
//                             backgroundColor: colors.secondary,
//                             color: "#fff",
//                             fontWeight: 'bold',
//                             fontSize: '0.75rem'
//                           }}
//                         />
//                       )}
//                     </ListItem>
//                     {index < searchResults.length - 1 && <Divider />}
//                   </React.Fragment>
//                 ))}
//               </List>
//             </Paper>
//           )}
//         </Box>

//         {/* Use Current Location */}
//         <FormControlLabel
//           control={
//             <Checkbox
//               checked={useCurrentLocation}
//               onChange={handleUseCurrentLocation}
//               sx={{ color: colors.secondary }}
//             />
//           }
//           label="Use my current location"
//           sx={{ mb: 3 }}
//         />

//         {/* Add Locations Section */}
//         <Box sx={{ mb: 3 }}>
//           <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
//             Add Locations
//           </Typography>
          
//           {/* Selected Locations Chips */}
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
//             {selectedLocations.map((location, index) => (
//               <Chip
//                 key={index}
//                 label={`+ ${location}`}
//                 onDelete={() => handleLocationRemove(location)}
//                 sx={{
//                   backgroundColor: colors.secondary,
//                   color: "#fff",
//                   fontWeight: 'bold',
//                   '& .MuiChip-deleteIcon': {
//                     color: "#fff"
//                   }
//                 }}
//               />
//             ))}
//             {selectedLocations.length < 3 && (
//               <Chip
//                 label="Add Location"
//                 onClick={() => setLocationDialogOpen(true)}
//                 variant="outlined"
//                 deleteIcon={<AddIcon />}
//                 onDelete={() => setLocationDialogOpen(true)}
//                 sx={{
//                   borderColor: colors.secondary,
//                   color: colors.secondary,
//                   '& .MuiChip-deleteIcon': {
//                     color: colors.secondary
//                   }
//                 }}
//               />
//             )}
//           </Box>

//           {/* Popular Cities */}
//           <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
//             Popular cities in India
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//             {popularCities.map((city, index) => (
//               <Chip
//                 key={index}
//                 label={`+${city}`}
//                 onClick={() => handleLocationSelect(city)}
//                 variant="outlined"
//                 sx={{
//                   borderColor: colors.secondary,
//                   color: colors.secondary,
//                   fontWeight: 'bold',
//                   '&:hover': {
//                     backgroundColor: colors.secondary,
//                     color: "#fff"
//                   }
//                 }}
//               />
//             ))}
//           </Box>
//         </Box>

//         {/* Property Type Filter */}
//         <Box sx={{ mb: 3 }}>
//           <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
//             Plot/ Building
//           </Typography>
//           <Chip
//             label={selectedPropertyTypes.length > 0 ? `${selectedPropertyTypes.length} selected` : "Select Property Types"}
//             onClick={() => setPropertyTypeDialogOpen(true)}
//             variant="outlined"
//             deleteIcon={<AddIcon />}
//             onDelete={() => setPropertyTypeDialogOpen(true)}
//             sx={{
//               borderColor: colors.secondary,
//               color: colors.secondary,
//               '& .MuiChip-deleteIcon': {
//                 color: colors.secondary
//               }
//             }}
//           />
//           {selectedPropertyTypes.length > 0 && (
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
//               {selectedPropertyTypes.map((type, index) => (
//                 <Chip
//                   key={index}
//                   label={type}
//                   onDelete={() => handlePropertyTypeSelect(type)}
//                   sx={{
//                     backgroundColor: colors.secondary,
//                     color: "#fff",
//                     '& .MuiChip-deleteIcon': {
//                       color: "#fff"
//                     }
//                   }}
//                 />
//               ))}
//             </Box>
//           )}
//         </Box>

//         {/* Tabs Section - Added after Plot/Building */}
//         <Box sx={{ mb: 4, backgroundColor: '#fff', borderRadius: 2, overflow: 'hidden', border: '1px solid #e0e0e0' }}>
//           <Typography variant="h6" sx={{ p: 2, fontWeight: 'bold', color: colors.primary, borderBottom: '1px solid #e0e0e0' }}>
//             Looking For
//           </Typography>
//           <Tabs 
//             value={activeTab} 
//             onChange={handleTabChange} 
//             variant="scrollable" 
//             scrollButtons="auto"
//             sx={{ 
//               '& .MuiTab-root': { 
//                 fontSize: '0.8rem', 
//                 fontWeight: 'bold', 
//                 color: colors.primary, 
//                 minWidth: 'auto', 
//                 px: 2, 
//                 py: 1.5,
//                 '&.Mui-selected': { color: colors.secondary } 
//               }, 
//               '& .MuiTabs-indicator': { backgroundColor: colors.secondary } 
//             }}
//           >
//             {filterTabs.map((tab, index) => (
//               <Tab key={index} label={tab.label} />
//             ))}
//           </Tabs>
//           <Box sx={{ p: 2, backgroundColor: '#f9f9f9', borderTop: '1px solid #e0e0e0' }}>
//             <Typography variant="body2" sx={{ color: colors.primary, fontStyle: 'italic' }}>
//               Selected: <strong>{filterTabs[activeTab]?.label || "None"}</strong>
//             </Typography>
//           </Box>
//         </Box>

//         {/* Apply Button */}
//         <Button
//           variant="contained"
//           fullWidth
//           onClick={handleApplyFilters}
//           sx={{
//             backgroundColor: colors.secondary,
//             color: "#fff",
//             py: 1.5,
//             fontSize: '1rem',
//             fontWeight: 'bold',
//             borderRadius: 2,
//             '&:hover': {
//               backgroundColor: "#A52A2A"
//             }
//           }}
//         >
//           Apply
//         </Button>
//       </Box>

//       {/* Location Dialog */}
//       <Dialog open={locationDialogOpen} onClose={() => setLocationDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Add Locations</Typography>
//             <IconButton onClick={() => setLocationDialogOpen(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={useCurrentLocation}
//                 onChange={handleUseCurrentLocation}
//                 sx={{ color: colors.secondary }}
//               />
//             }
//             label="Use my current location"
//           />
//           <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
//             Selected Locations
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
//             {selectedLocations.map((location, index) => (
//               <Chip
//                 key={index}
//                 label={`+ ${location}`}
//                 onDelete={() => handleLocationRemove(location)}
//                 sx={{
//                   backgroundColor: colors.secondary,
//                   color: "#fff",
//                   '& .MuiChip-deleteIcon': {
//                     color: "#fff"
//                   }
//                 }}
//               />
//             ))}
//           </Box>
//           <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
//             Popular cities in India
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//             {popularCities.map((city, index) => (
//               <Chip
//                 key={index}
//                 label={`+${city}`}
//                 onClick={() => handleLocationSelect(city)}
//                 variant="outlined"
//                 sx={{
//                   borderColor: colors.secondary,
//                   color: colors.secondary,
//                   '&:hover': {
//                     backgroundColor: colors.secondary,
//                     color: "#fff"
//                   }
//                 }}
//               />
//             ))}
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button
//             onClick={() => setLocationDialogOpen(false)}
//             variant="contained"
//             fullWidth
//             sx={{
//               backgroundColor: colors.secondary,
//               color: "#fff",
//               '&:hover': { backgroundColor: "#A52A2A" }
//             }}
//           >
//             Done
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Property Type Dialog */}
//       <Dialog open={propertyTypeDialogOpen} onClose={() => setPropertyTypeDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Select Property Type</Typography>
//             <IconButton onClick={() => setPropertyTypeDialogOpen(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <List>
//             {propertyTypes.map((type, index) => (
//               <ListItem
//                 key={index}
//                 button
//                 onClick={() => handlePropertyTypeSelect(type)}
//                 sx={{
//                   borderBottom: '1px solid #e0e0e0',
//                   '&:last-child': { borderBottom: 'none' }
//                 }}
//               >
//                 <Checkbox
//                   checked={selectedPropertyTypes.includes(type)}
//                   sx={{ color: colors.secondary }}
//                 />
//                 <ListItemText primary={type} />
//               </ListItem>
//             ))}
//           </List>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button
//             onClick={() => setPropertyTypeDialogOpen(false)}
//             variant="contained"
//             fullWidth
//             sx={{
//               backgroundColor: colors.secondary,
//               color: "#fff",
//               '&:hover': { backgroundColor: "#A52A2A" }
//             }}
//           >
//             Done
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default PropertySearchFilters;

//==========================================================================

// search functionality related to 99 - Acres website 


// import React, { useState } from "react";
// import {
//   Box,
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   TextField,
//   Chip,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   List,
//   ListItem,
//   ListItemText,
//   InputAdornment,
//   Paper,
//   Slider,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Divider,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Grid
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import SearchIcon from "@mui/icons-material/Search";
// import AddIcon from "@mui/icons-material/Add";
// import CloseIcon from "@mui/icons-material/Close";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import { useNavigate } from "react-router-dom";

// const PropertySearchFilters = () => {
//   const navigate = useNavigate();
  
//   // State for all filters
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedLocations, setSelectedLocations] = useState([]);
//   const [useCurrentLocation, setUseCurrentLocation] = useState(false);
  
//   // Budget State
//   const [budget, setBudget] = useState([0, 50000000]); // 0 to 5 crore
  
//   // Property Types
//   const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
  
//   // Bedrooms
//   const [bedrooms, setBedrooms] = useState([]);
  
//   // Construction Status
//   const [constructionStatus, setConstructionStatus] = useState([]);
  
//   // Advanced Filters State
//   const [postedBy, setPostedBy] = useState([]);
//   const [purchaseType, setPurchaseType] = useState([]);
//   const [area, setArea] = useState([0, 10000]); // sq.ft
//   const [bathrooms, setBathrooms] = useState(0);
//   const [furnishingStatus, setFurnishingStatus] = useState([]);
//   const [amenities, setAmenities] = useState([]);
  
//   // Dialog States
//   const [locationDialogOpen, setLocationDialogOpen] = useState(false);
//   const [propertyTypeDialogOpen, setPropertyTypeDialogOpen] = useState(false);
//   const [bedroomsDialogOpen, setBedroomsDialogOpen] = useState(false);
//   const [constructionDialogOpen, setConstructionDialogOpen] = useState(false);
//   const [advancedDialogOpen, setAdvancedDialogOpen] = useState(false);
  
//   // Advanced Filter Sections State
//   const [expandedAdvancedSection, setExpandedAdvancedSection] = useState(null);
  
//   // Data Arrays
//   const popularCities = ["Mumbai", "Delhi", "Bangalore", "Hyderabad", "Chennai", "Pune", "Kolkata"];
//   const propertyTypesList = ["Flat/Apartment", "House/Villa", "Serviced Apartment", "Plot", "Commercial"];
//   const bedroomsList = ["1 BHK", "2 BHK", "3 BHK", "4 BHK", "5+ BHK"];
//   const constructionStatusList = ["Ready to Move", "New Launch", "Under Construction"];
//   const postedByList = ["Owner", "Dealer", "Builder"];
//   const purchaseTypeList = ["Resale", "New Booking"];
//   const furnishingStatusList = ["Furnished", "Semi-Furnished", "Unfurnished"];
//   const amenitiesList = ["Parking", "Power Backup", "Swimming Pool", "Gym", "Security", "Garden", "Lift"];
  
//   const colors = {
//     primary: "#1a1a1a",
//     secondary: "#8B7355",
//     background: "#f5f5f5",
//     chip: "#e0e0e0"
//   };

//   // Handler Functions
//   const handleLocationSelect = (location) => {
//     if (selectedLocations.length < 3 && !selectedLocations.includes(location)) {
//       setSelectedLocations([...selectedLocations, location]);
//     }
//   };

//   const handleLocationRemove = (locationToRemove) => {
//     setSelectedLocations(selectedLocations.filter(location => location !== locationToRemove));
//   };

//   const handleUseCurrentLocation = () => {
//     setUseCurrentLocation(!useCurrentLocation);
//     if (!useCurrentLocation) {
//       setSelectedLocations([...selectedLocations, "My Current Location"]);
//     } else {
//       setSelectedLocations(selectedLocations.filter(loc => loc !== "My Current Location"));
//     }
//   };

//   const handleBudgetChange = (event, newValue) => {
//     setBudget(newValue);
//   };

//   const formatBudgetValue = (value) => {
//     if (value >= 10000000) return `${value / 10000000} Cr`;
//     if (value >= 100000) return `${value / 100000} L`;
//     return `${value}`;
//   };

//   const handleToggleSelection = (item, stateArray, setStateFunction) => {
//     if (stateArray.includes(item)) {
//       setStateFunction(stateArray.filter(i => i !== item));
//     } else {
//       setStateFunction([...stateArray, item]);
//     }
//   };

//   const handleApplyFilters = () => {
//     const filters = {
//       searchQuery,
//       selectedLocations,
//       useCurrentLocation,
//       budget: { min: budget[0], max: budget[1] },
//       propertyTypes: selectedPropertyTypes,
//       bedrooms,
//       constructionStatus,
//       postedBy,
//       purchaseType,
//       area: { min: area[0], max: area[1] },
//       bathrooms,
//       furnishingStatus,
//       amenities
//     };
    
//     console.log("Applied Filters:", filters);
    
//     navigate('/property-results', {
//       state: { filters }
//     });
//   };

//   const handleResetFilters = () => {
//     setBudget([0, 50000000]);
//     setSelectedPropertyTypes([]);
//     setBedrooms([]);
//     setConstructionStatus([]);
//     setPostedBy([]);
//     setPurchaseType([]);
//     setArea([0, 10000]);
//     setBathrooms(0);
//     setFurnishingStatus([]);
//     setAmenities([]);
//   };

//   const handleAdvancedSectionToggle = (section) => {
//     setExpandedAdvancedSection(expandedAdvancedSection === section ? null : section);
//   };

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background }}>
//       {/* Header */}
//       <AppBar position="sticky" sx={{ backgroundColor: colors.primary, color: "#fff" }}>
//         <Toolbar>
//           <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography variant="h6" sx={{ ml: 2 }}>Property Search</Typography>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 2, flex: 1, overflow: 'auto' }}>
//         {/* Location Search */}
//         <Box sx={{ mb: 3 }}>
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder="Search Location"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon sx={{ color: colors.secondary }} />
//                 </InputAdornment>
//               )
//             }}
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 2,
//                 backgroundColor: '#fff',
//                 '&:hover fieldset': { borderColor: colors.secondary }
//               }
//             }}
//           />
          
//           {/* Selected Locations Chips */}
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
//             {selectedLocations.map((location, index) => (
//               <Chip
//                 key={index}
//                 label={location}
//                 onDelete={() => handleLocationRemove(location)}
//                 sx={{
//                   backgroundColor: colors.secondary,
//                   color: "#fff",
//                   '& .MuiChip-deleteIcon': { color: "#fff" }
//                 }}
//               />
//             ))}
//             {selectedLocations.length < 3 && (
//               <Chip
//                 label="Add Location"
//                 onClick={() => setLocationDialogOpen(true)}
//                 variant="outlined"
//                 sx={{ borderColor: colors.secondary, color: colors.secondary }}
//               />
//             )}
//           </Box>
//         </Box>

//         {/* Budget Filter */}
//         <Paper elevation={0} sx={{ p: 2, mb: 3, backgroundColor: '#fff', borderRadius: 2 }}>
//           <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>
//             Budget (₹)
//           </Typography>
//           <Box sx={{ px: 1 }}>
//             <Slider
//               value={budget}
//               onChange={handleBudgetChange}
//               valueLabelDisplay="auto"
//               valueLabelFormat={formatBudgetValue}
//               min={0}
//               max={100000000}
//               step={100000}
//               sx={{
//                 color: colors.secondary,
//                 '& .MuiSlider-valueLabel': {
//                   backgroundColor: colors.secondary
//                 }
//               }}
//             />
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
//               <Typography variant="body2" color="text.secondary">
//                 Min: ₹{formatBudgetValue(budget[0])}
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Max: ₹{formatBudgetValue(budget[1])}
//               </Typography>
//             </Box>
//           </Box>
//         </Paper>

//         {/* Property Type Filter */}
//         <Paper elevation={0} sx={{ p: 2, mb: 3, backgroundColor: '#fff', borderRadius: 2 }}>
//           <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>
//             Property Type
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//             {propertyTypesList.map((type) => (
//               <Chip
//                 key={type}
//                 label={type}
//                 onClick={() => handleToggleSelection(type, selectedPropertyTypes, setSelectedPropertyTypes)}
//                 variant={selectedPropertyTypes.includes(type) ? "filled" : "outlined"}
//                 sx={{
//                   borderColor: colors.secondary,
//                   backgroundColor: selectedPropertyTypes.includes(type) ? colors.secondary : 'transparent',
//                   color: selectedPropertyTypes.includes(type) ? '#fff' : colors.secondary
//                 }}
//               />
//             ))}
//           </Box>
//         </Paper>

//         {/* Bedrooms Filter */}
//         <Paper elevation={0} sx={{ p: 2, mb: 3, backgroundColor: '#fff', borderRadius: 2 }}>
//           <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>
//             No. of Bedrooms
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//             {bedroomsList.map((beds) => (
//               <Chip
//                 key={beds}
//                 label={beds}
//                 onClick={() => handleToggleSelection(beds, bedrooms, setBedrooms)}
//                 variant={bedrooms.includes(beds) ? "filled" : "outlined"}
//                 sx={{
//                   borderColor: colors.secondary,
//                   backgroundColor: bedrooms.includes(beds) ? colors.secondary : 'transparent',
//                   color: bedrooms.includes(beds) ? '#fff' : colors.secondary
//                 }}
//               />
//             ))}
//           </Box>
//         </Paper>

//         {/* Construction Status Filter */}
//         <Paper elevation={0} sx={{ p: 2, mb: 3, backgroundColor: '#fff', borderRadius: 2 }}>
//           <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>
//             Construction Status
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//             {constructionStatusList.map((status) => (
//               <Chip
//                 key={status}
//                 label={status}
//                 onClick={() => handleToggleSelection(status, constructionStatus, setConstructionStatus)}
//                 variant={constructionStatus.includes(status) ? "filled" : "outlined"}
//                 sx={{
//                   borderColor: colors.secondary,
//                   backgroundColor: constructionStatus.includes(status) ? colors.secondary : 'transparent',
//                   color: constructionStatus.includes(status) ? '#fff' : colors.secondary
//                 }}
//               />
//             ))}
//           </Box>
//         </Paper>

//         {/* Advanced Filters Accordion */}
//         <Accordion 
//           elevation={0} 
//           sx={{ 
//             mb: 3, 
//             backgroundColor: '#fff', 
//             borderRadius: '2px !important',
//             '&:before': { display: 'none' }
//           }}
//         >
//           <AccordionSummary
//             expandIcon={<ExpandMoreIcon />}
//             sx={{
//               borderBottom: '1px solid #e0e0e0',
//               minHeight: '48px',
//               '& .MuiAccordionSummary-content': { my: 0 }
//             }}
//           >
//             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: colors.primary }}>
//               Advanced Filters
//             </Typography>
//           </AccordionSummary>
//           <AccordionDetails sx={{ p: 0 }}>
//             {/* Posted By */}
//             <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
//               <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>
//                 Posted By
//               </Typography>
//               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                 {postedByList.map((type) => (
//                   <Chip
//                     key={type}
//                     label={type}
//                     onClick={() => handleToggleSelection(type, postedBy, setPostedBy)}
//                     variant={postedBy.includes(type) ? "filled" : "outlined"}
//                     size="small"
//                     sx={{
//                       borderColor: colors.secondary,
//                       backgroundColor: postedBy.includes(type) ? colors.secondary : 'transparent',
//                       color: postedBy.includes(type) ? '#fff' : colors.secondary
//                     }}
//                   />
//                 ))}
//               </Box>
//             </Box>

//             {/* Purchase Type */}
//             <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
//               <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>
//                 Purchase Type
//               </Typography>
//               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                 {purchaseTypeList.map((type) => (
//                   <Chip
//                     key={type}
//                     label={type}
//                     onClick={() => handleToggleSelection(type, purchaseType, setPurchaseType)}
//                     variant={purchaseType.includes(type) ? "filled" : "outlined"}
//                     size="small"
//                     sx={{
//                       borderColor: colors.secondary,
//                       backgroundColor: purchaseType.includes(type) ? colors.secondary : 'transparent',
//                       color: purchaseType.includes(type) ? '#fff' : colors.secondary
//                     }}
//                   />
//                 ))}
//               </Box>
//             </Box>

//             {/* Area */}
//             <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
//               <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>
//                 Area (sq.ft)
//               </Typography>
//               <Box sx={{ px: 1 }}>
//                 <Slider
//                   value={area}
//                   onChange={(e, newValue) => setArea(newValue)}
//                   valueLabelDisplay="auto"
//                   min={0}
//                   max={10000}
//                   step={100}
//                   sx={{ color: colors.secondary }}
//                 />
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
//                   <Typography variant="caption" color="text.secondary">
//                     Min: {area[0]} sq.ft
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     Max: {area[1]} sq.ft
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>

//             {/* Bathrooms */}
//             <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
//               <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>
//                 Minimum Bathrooms
//               </Typography>
//               <FormControl fullWidth size="small">
//                 <Select
//                   value={bathrooms}
//                   onChange={(e) => setBathrooms(e.target.value)}
//                   sx={{
//                     '& .MuiSelect-select': { py: 1 },
//                     '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.secondary }
//                   }}
//                 >
//                   <MenuItem value={0}>0+</MenuItem>
//                   <MenuItem value={1}>1+</MenuItem>
//                   <MenuItem value={2}>2+</MenuItem>
//                   <MenuItem value={3}>3+</MenuItem>
//                   <MenuItem value={4}>4+</MenuItem>
//                 </Select>
//               </FormControl>
//             </Box>

//             {/* Furnishing Status */}
//             <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
//               <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>
//                 Furnishing Status
//               </Typography>
//               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                 {furnishingStatusList.map((status) => (
//                   <Chip
//                     key={status}
//                     label={status}
//                     onClick={() => handleToggleSelection(status, furnishingStatus, setFurnishingStatus)}
//                     variant={furnishingStatus.includes(status) ? "filled" : "outlined"}
//                     size="small"
//                     sx={{
//                       borderColor: colors.secondary,
//                       backgroundColor: furnishingStatus.includes(status) ? colors.secondary : 'transparent',
//                       color: furnishingStatus.includes(status) ? '#fff' : colors.secondary
//                     }}
//                   />
//                 ))}
//               </Box>
//             </Box>

//             {/* Amenities */}
//             <Box sx={{ p: 2 }}>
//               <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'bold', color: colors.primary }}>
//                 Amenities
//               </Typography>
//               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                 {amenitiesList.map((amenity) => (
//                   <Chip
//                     key={amenity}
//                     label={amenity}
//                     onClick={() => handleToggleSelection(amenity, amenities, setAmenities)}
//                     variant={amenities.includes(amenity) ? "filled" : "outlined"}
//                     size="small"
//                     sx={{
//                       borderColor: colors.secondary,
//                       backgroundColor: amenities.includes(amenity) ? colors.secondary : 'transparent',
//                       color: amenities.includes(amenity) ? '#fff' : colors.secondary
//                     }}
//                   />
//                 ))}
//               </Box>
//             </Box>
//           </AccordionDetails>
//         </Accordion>

//         {/* Action Buttons */}
//         <Grid container spacing={2} sx={{ mt: 2 }}>
//           <Grid item xs={6}>
//             <Button
//               variant="outlined"
//               fullWidth
//               onClick={handleResetFilters}
//               sx={{
//                 borderColor: colors.secondary,
//                 color: colors.secondary,
//                 py: 1.5,
//                 borderRadius: 2,
//                 '&:hover': {
//                   borderColor: colors.secondary,
//                   backgroundColor: 'rgba(139, 115, 85, 0.1)'
//                 }
//               }}
//             >
//               Reset
//             </Button>
//           </Grid>
//           <Grid item xs={6}>
//             <Button
//               variant="contained"
//               fullWidth
//               onClick={handleApplyFilters}
//               sx={{
//                 backgroundColor: colors.secondary,
//                 color: "#fff",
//                 py: 1.5,
//                 borderRadius: 2,
//                 fontSize: '1rem',
//                 fontWeight: 'bold',
//                 '&:hover': {
//                   backgroundColor: "#A52A2A"
//                 }
//               }}
//             >
//               Apply
//             </Button>
//           </Grid>
//         </Grid>
//       </Box>

//       {/* Location Dialog */}
//       <Dialog open={locationDialogOpen} onClose={() => setLocationDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Add Locations</Typography>
//             <IconButton onClick={() => setLocationDialogOpen(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={useCurrentLocation}
//                 onChange={handleUseCurrentLocation}
//                 sx={{ color: colors.secondary }}
//               />
//             }
//             label="Use my current location"
//           />
//           <Typography variant="subtitle1" sx={{ mt: 3, mb: 2, fontWeight: 'bold' }}>
//             Popular cities in India
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//             {popularCities.map((city) => (
//               <Chip
//                 key={city}
//                 label={city}
//                 onClick={() => handleLocationSelect(city)}
//                 variant={selectedLocations.includes(city) ? "filled" : "outlined"}
//                 sx={{
//                   borderColor: colors.secondary,
//                   backgroundColor: selectedLocations.includes(city) ? colors.secondary : 'transparent',
//                   color: selectedLocations.includes(city) ? '#fff' : colors.secondary,
//                   '&:hover': {
//                     backgroundColor: colors.secondary,
//                     color: "#fff"
//                   }
//                 }}
//               />
//             ))}
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button
//             onClick={() => setLocationDialogOpen(false)}
//             variant="contained"
//             fullWidth
//             sx={{
//               backgroundColor: colors.secondary,
//               color: "#fff",
//               '&:hover': { backgroundColor: "#A52A2A" }
//             }}
//           >
//             Done
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default PropertySearchFilters;



// --------------------------------------------------

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import {
//   Box,
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   TextField,
//   Chip,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   InputAdornment,
//   Tabs,
//   Tab,
//   Paper,
//   Divider,
//   CircularProgress,
//   Alert,
//   Snackbar,
//   Avatar,
//   ListItemAvatar
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import SearchIcon from "@mui/icons-material/Search";
// import AddIcon from "@mui/icons-material/Add";
// import CloseIcon from "@mui/icons-material/Close";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import ApartmentIcon from "@mui/icons-material/Apartment";
// import HomeWorkIcon from "@mui/icons-material/HomeWork";
// import MyLocationIcon from "@mui/icons-material/MyLocation";
// import WarningIcon from "@mui/icons-material/Warning";
// import NearMeIcon from "@mui/icons-material/NearMe";
// import { useNavigate } from "react-router-dom";
// import { popularCities, propertyTypes, tabs as filterTabs } from "./propertyFilters";
// import { GOOGLEMAPS_API_KEY } from './../../Api/ApiUrls';

// const GOOGLE_MAPS_API_KEY = GOOGLEMAPS_API_KEY;
// const API_ENDPOINT = "https://landnest.net:81/property-request/";

// const PropertySearchFilters = () => {
//   const navigate = useNavigate();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedLocations, setSelectedLocations] = useState([]);
//   const [useCurrentLocation, setUseCurrentLocation] = useState(false);
//   const [propertyTypeDialogOpen, setPropertyTypeDialogOpen] = useState(false);
//   const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
//   const [locationDialogOpen, setLocationDialogOpen] = useState(false);
//   const [activeTab, setActiveTab] = useState(0);
//   const [searchResults, setSearchResults] = useState([]);
//   const [showSearchResults, setShowSearchResults] = useState(false);
//   const [isSearching, setIsSearching] = useState(false);
//   const [apiData, setApiData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [googleMapsResults, setGoogleMapsResults] = useState([]);
//   const [showNoResults, setShowNoResults] = useState(false);
//   const [currentLocation, setCurrentLocation] = useState(null);
//   const [nearbyLocations, setNearbyLocations] = useState([]);
//   const [selectedLocationCoordinates, setSelectedLocationCoordinates] = useState(null);
//   const searchTimeoutRef = useRef(null);

//   const colors = {
//     primary: "#1a1a1a",
//     secondary: "#8B7355",
//     background: "#f5f5f5",
//     warning: "#ff9800",
//     error: "#f44336",
//     nearby: "#1976d2"
//   };

//   // Calculate distance between two coordinates using Haversine formula
//   const calculateDistance = (lat1, lon1, lat2, lon2) => {
//     const R = 6371; // Earth's radius in kilometers
//     const dLat = (lat2 - lat1) * Math.PI / 180;
//     const dLon = (lon2 - lon1) * Math.PI / 180;
//     const a = 
//       Math.sin(dLat/2) * Math.sin(dLat/2) +
//       Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
//       Math.sin(dLon/2) * Math.sin(dLon/2);
//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
//     return R * c; // Distance in kilometers
//   };

//   // Find nearby locations within 5km radius
//   const findNearbyLocations = (centerLat, centerLng, allLocations) => {
//     if (!centerLat || !centerLng || !allLocations || !Array.isArray(allLocations)) {
//       return [];
//     }

//     const MAX_DISTANCE_KM = 5; // 5 kilometers radius
    
//     return allLocations.filter(location => {
//       if (!location.lat || !location.long) return false;
      
//       const distance = calculateDistance(
//         centerLat, centerLng,
//         parseFloat(location.lat), parseFloat(location.long)
//       );
      
//       return distance <= MAX_DISTANCE_KM;
//     });
//   };

//   // Fetch API data on component mount
//   useEffect(() => {
//     fetchPropertyRequests();
//   }, []);

//   const fetchPropertyRequests = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await fetch(API_ENDPOINT, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();
      
//       if (!Array.isArray(data)) {
//         throw new Error('API response is not an array');
//       }
      
//       const processedData = processApiData(data);
//       setApiData(processedData);
      
//       localStorage.setItem('propertyRequestsCache', JSON.stringify(processedData));
      
//     } catch (err) {
//       console.error('Error fetching property requests:', err);
//       setError(`Failed to load property data: ${err.message}`);
      
//       const cachedData = localStorage.getItem('propertyRequestsCache');
//       if (cachedData) {
//         try {
//           setApiData(JSON.parse(cachedData));
//         } catch (parseError) {
//           console.error('Error parsing cached data:', parseError);
//         }
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Process API data to extract searchable locations and counts
//   const processApiData = (data) => {
//     if (!Array.isArray(data)) return [];
    
//     const locationMap = new Map();
    
//     data.forEach(request => {
//       if (request && request.pro_loc && Array.isArray(request.pro_loc)) {
//         request.pro_loc.forEach(location => {
//           const locName = location?.location || '';
//           if (locName && typeof locName === 'string') {
//             const nameParts = locName.split(',');
//             const primaryName = nameParts.length > 0 ? nameParts[0].trim() : locName.trim();
//             const cityName = nameParts.length > 1 ? nameParts[1].trim() : primaryName;
            
//             if (locationMap.has(locName)) {
//               const existing = locationMap.get(locName);
//               locationMap.set(locName, {
//                 ...existing,
//                 count: existing.count + 1,
//                 requests: [...(existing.requests || []), request.req_id]
//               });
//             } else {
//               locationMap.set(locName, {
//                 name: primaryName,
//                 fullLocation: locName,
//                 city: cityName,
//                 type: determineLocationType(locName),
//                 count: 1,
//                 requests: [request.req_id],
//                 lat: location?.lat,
//                 long: location?.long,
//                 isFromAPI: true,
//                 propertiesCount: 1
//               });
//             }
//           }
//         });
//       }
//     });
    
//     return Array.from(locationMap.values());
//   };

//   // Determine location type based on the location string
//   const determineLocationType = (location) => {
//     if (!location || typeof location !== 'string') return "city";
    
//     const locLower = location.toLowerCase();
//     if (locLower.includes('layout') || locLower.includes('colony') || locLower.includes('nagar') || 
//         locLower.includes('society') || locLower.includes('village') || locLower.includes('town')) {
//       return "locality";
//     } else if (locLower.includes('apartment') || locLower.includes('towers') || locLower.includes('heights') ||
//                locLower.includes('complex') || locLower.includes('residency') || locLower.includes('estate')) {
//       return "project";
//     } else if (locLower.includes('street') || locLower.includes('road') || locLower.includes('lane') ||
//                locLower.includes('avenue') || locLower.includes('boulevard')) {
//       return "address";
//     } else {
//       return "city";
//     }
//   };

//   // Search Google Maps API for locations
//   const searchGoogleMaps = useCallback(async (query) => {
//     if (!query.trim() || !GOOGLE_MAPS_API_KEY) {
//       setGoogleMapsResults([]);
//       return [];
//     }

//     try {
//       const encodedQuery = encodeURIComponent(query);
//       const url = `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${encodedQuery}&key=${GOOGLE_MAPS_API_KEY}&components=country:in`;
      
//       const response = await fetch(url);
//       const data = await response.json();
      
//       if (data.status === 'OK' && data.predictions) {
//         // For each prediction, fetch place details to get coordinates
//         const results = await Promise.all(
//           data.predictions.slice(0, 3).map(async (prediction) => {
//             try {
//               // Get place details for coordinates
//               const detailsUrl = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${prediction.place_id}&fields=geometry,name,formatted_address&key=${GOOGLE_MAPS_API_KEY}`;
//               const detailsResponse = await fetch(detailsUrl);
//               const detailsData = await detailsResponse.json();
              
//               return {
//                 id: prediction.place_id,
//                 name: prediction.structured_formatting.main_text,
//                 description: prediction.structured_formatting.secondary_text || '',
//                 fullAddress: prediction.description,
//                 type: 'google',
//                 isFromGoogle: true,
//                 lat: detailsData.result?.geometry?.location?.lat,
//                 lng: detailsData.result?.geometry?.location?.lng
//               };
//             } catch (error) {
//               console.error('Error fetching place details:', error);
//               return {
//                 id: prediction.place_id,
//                 name: prediction.structured_formatting.main_text,
//                 description: prediction.structured_formatting.secondary_text || '',
//                 fullAddress: prediction.description,
//                 type: 'google',
//                 isFromGoogle: true
//               };
//             }
//           })
//         );
//         setGoogleMapsResults(results);
//         return results;
//       } else {
//         setGoogleMapsResults([]);
//         return [];
//       }
//     } catch (error) {
//       console.error('Error searching Google Maps:', error);
//       setGoogleMapsResults([]);
//       return [];
//     }
//   }, [GOOGLE_MAPS_API_KEY]);

//   // Get current location using browser geolocation
//   const getCurrentLocation = () => {
//     if (!navigator.geolocation) {
//       setError("Geolocation is not supported by your browser");
//       return;
//     }

//     setIsSearching(true);
//     navigator.geolocation.getCurrentPosition(
//       async (position) => {
//         const { latitude, longitude } = position.coords;
//         setCurrentLocation({ lat: latitude, lng: longitude });
        
//         try {
//           // Reverse geocode to get location name
//           const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`;
//           const response = await fetch(url);
//           const data = await response.json();
          
//           if (data.status === 'OK' && data.results[0]) {
//             const locationName = data.results[0].formatted_address;
//             const locationData = {
//               name: "My Current Location",
//               fullLocation: locationName,
//               type: "current",
//               lat: latitude,
//               long: longitude,
//               isCurrentLocation: true,
//               count: 0
//             };
            
//             handleLocationSelect(locationData);
            
//             // Find nearby locations for current location
//             const nearby = findNearbyLocations(latitude, longitude, apiData)
//               .map(location => ({
//                 ...location,
//                 isNearby: true,
//                 distance: calculateDistance(
//                   latitude,
//                   longitude,
//                   parseFloat(location.lat),
//                   parseFloat(location.long)
//                 ).toFixed(1)
//               }));
//             setNearbyLocations(nearby);
//           }
//         } catch (error) {
//           console.error('Error reverse geocoding:', error);
//         } finally {
//           setIsSearching(false);
//         }
//       },
//       (error) => {
//         console.error('Error getting location:', error);
//         setError("Unable to get your current location");
//         setIsSearching(false);
//       },
//       { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
//     );
//   };

//   // Debounced search with API and Google Maps
//   useEffect(() => {
//     if (searchQuery.trim() === "") {
//       setSearchResults([]);
//       setGoogleMapsResults([]);
//       setNearbyLocations([]);
//       setShowSearchResults(false);
//       setShowNoResults(false);
//       return;
//     }

//     setIsSearching(true);
//     setShowNoResults(false);
//     setNearbyLocations([]);

//     // Clear previous timeout
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }

//     searchTimeoutRef.current = setTimeout(async () => {
//       try {
//         const queryLower = searchQuery.toLowerCase().trim();
        
//         // 1. Search in API data
//         const apiResults = searchInApiData(queryLower);
        
//         // 2. Search Google Maps (only if we have API key and query is meaningful)
//         let googleResults = [];
//                 let searchLocationCoords = null;

//         if (GOOGLE_MAPS_API_KEY && queryLower.length >= 2) {
//           googleResults = await searchGoogleMaps(searchQuery);
//         }
        
//         // 3. Combine results
//         const allResults = [...apiResults, ...googleResults];
        
//         // 4. Find nearby locations for Google Maps results with coordinates
//         let nearbyResults = [];
//         if (googleResults.length > 0) {
//           const googleResultWithCoords = googleResults.find(r => r.lat && r.lng);
//           if (googleResultWithCoords) {
//             nearbyResults = findNearbyLocations(
//               googleResultWithCoords.lat,
//               googleResultWithCoords.lng,
//               apiData
//             ).map(location => ({
//               ...location,
//               isNearby: true,
//               distance: calculateDistance(
//                 googleResultWithCoords.lat,
//                 googleResultWithCoords.lng,
//                 parseFloat(location.lat),
//                 parseFloat(location.long)
//               ).toFixed(1)
//             }));
//           }
//         }
        
//         // 5. Combine all results
//         const allUniqueResults = [...allResults];
//         nearbyResults.forEach(nearby => {
//           if (!allUniqueResults.some(item => item.fullLocation === nearby.fullLocation)) {
//             allUniqueResults.push(nearby);
//           }
//         });
        
//         // 6. Remove duplicates
//         const uniqueResults = allUniqueResults.reduce((acc, current) => {
//           const exists = acc.find(item => 
//             item.fullLocation === current.fullLocation || 
//             item.name === current.name
//           );
//           if (!exists) {
//             acc.push(current);
//           }
//           return acc;
//         }, []);
        
//         // 7. Sort results
//         uniqueResults.sort((a, b) => {
//           // Exact API matches first
//           if (a.isFromAPI && b.isFromAPI) {
//             return (b.count || 0) - (a.count || 0);
//           }
//           if (a.isFromAPI && !b.isFromAPI) return -1;
//           if (!a.isFromAPI && b.isFromAPI) return 1;
          
//           // Nearby results after exact matches
//           if (a.isNearby && !b.isNearby) return -1;
//           if (!a.isNearby && b.isNearby) return 1;
          
//           // Then Google results
//           return 0;
//         });
        
//         setSearchResults(uniqueResults);
//         setNearbyLocations(nearbyResults);
//         setShowSearchResults(true);
//         setShowNoResults(uniqueResults.length === 0);
        
//       } catch (error) {
//         console.error('Search error:', error);
//         setSearchResults([]);
//         setShowNoResults(true);
//       } finally {
//         setIsSearching(false);
//       }
//     }, 500);

//     return () => {
//       if (searchTimeoutRef.current) {
//         clearTimeout(searchTimeoutRef.current);
//       }
//     };
//   }, [searchQuery, apiData, searchGoogleMaps]);

//   const searchInApiData = (queryLower) => {
//     if (!apiData || !Array.isArray(apiData) || apiData.length === 0) {
//       return [];
//     }

//     // Search in multiple fields
//     const filteredResults = apiData.filter(item => {
//       if (!item) return false;
      
//       const name = (item.name || '').toLowerCase();
//       const fullLocation = (item.fullLocation || '').toLowerCase();
//       const city = (item.city || '').toLowerCase();
      
//       return (
//         name.includes(queryLower) ||
//         fullLocation.includes(queryLower) ||
//         city.includes(queryLower)
//       );
//     });

//     return filteredResults;
//   };

//   const handleLocationSelect = (location) => {
//     if (!location || !location.name) return;
    
//     if (selectedLocations.length < 3 && !selectedLocations.some(loc => loc.name === location.name)) {
//       setSelectedLocations([...selectedLocations, location]);
//       setSearchQuery("");
//       setShowSearchResults(false);
//       setShowNoResults(false);
      
//       // If location has coordinates, find nearby locations
//       if (location.lat && location.long) {
//         const nearby = findNearbyLocations(
//           location.lat,
//           location.long,
//           apiData
//         ).map(loc => ({
//           ...loc,
//           isNearby: true,
//           distance: calculateDistance(
//             location.lat,
//             location.long,
//             parseFloat(loc.lat),
//             parseFloat(loc.long)
//           ).toFixed(1)
//         }));
//         setNearbyLocations(nearby);
//       }
//     }
//   };

//   const handleLocationRemove = (locationToRemove) => {
//     if (!locationToRemove || !locationToRemove.name) return;
    
//     setSelectedLocations(selectedLocations.filter(location => 
//       location?.name !== locationToRemove.name
//     ));
    
//     // If removing current location, update the checkbox
//     if (locationToRemove.name === "My Current Location") {
//       setUseCurrentLocation(false);
//     }
//   };

//   const handlePropertyTypeSelect = (type) => {
//     if (selectedPropertyTypes.includes(type)) {
//       setSelectedPropertyTypes(selectedPropertyTypes.filter(t => t !== type));
//     } else {
//       setSelectedPropertyTypes([...selectedPropertyTypes, type]);
//     }
//   };

//   const handleUseCurrentLocation = () => {
//     const newUseCurrentLocation = !useCurrentLocation;
//     setUseCurrentLocation(newUseCurrentLocation);
    
//     if (newUseCurrentLocation) {
//       getCurrentLocation();
//     } else {
//       // Remove current location if it exists
//       setSelectedLocations(selectedLocations.filter(loc => 
//         loc?.name !== "My Current Location"
//       ));
//       setNearbyLocations([]);
//     }
//   };

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

//   const handleApplyFilters = () => {
//     // Navigate to results page with filter parameters
//     navigate('/property-results', {
//       state: {
//         filters: {
//           searchQuery,
//           selectedLocations,
//           selectedPropertyTypes,
//           useCurrentLocation,
//           activeTab: activeTab,
//           nearbyLocations: nearbyLocations
//         }
//       }
//     });
//   };

//   const handleSearchResultClick = (result) => {
//     handleLocationSelect(result);
//   };

//   const getLocationIcon = (type) => {
//     if (!type) return <LocationOnIcon sx={{ color: colors.secondary }} />;
    
//     switch (type) {
//       case "city":
//         return <LocationOnIcon sx={{ color: "#1976d2" }} />;
//       case "locality":
//         return <HomeWorkIcon sx={{ color: "#388e3c" }} />;
//       case "project":
//         return <ApartmentIcon sx={{ color: "#7b1fa2" }} />;
//       case "address":
//         return <LocationOnIcon sx={{ color: "#f57c00" }} />;
//       case "current":
//         return <MyLocationIcon sx={{ color: "#4CAF50" }} />;
//       case "google":
//         return <LocationOnIcon sx={{ color: colors.secondary }} />;
//       case "nearby":
//         return <NearMeIcon sx={{ color: colors.nearby }} />;
//       default:
//         return <LocationOnIcon sx={{ color: colors.secondary }} />;
//     }
//   };

//   const handleCloseError = () => {
//     setError(null);
//   };

//   const safeGet = (obj, property, defaultValue = '') => {
//     return obj && obj[property] !== undefined ? obj[property] : defaultValue;
//   };

//   const getResultCountText = (count) => {
//     if (count === 0) return "No properties";
//     if (count === 1) return "1 property";
//     return `${count} properties`;
//   };

//   const getGoogleMapsIcon = () => (
//     <Box sx={{ 
//       width: 20, 
//       height: 20, 
//       borderRadius: '50%', 
//       backgroundColor: '#4285F4', 
//       display: 'flex', 
//       alignItems: 'center', 
//       justifyContent: 'center',
//       mr: 1
//     }}>
//       <Typography variant="caption" sx={{ color: 'white', fontWeight: 'bold' }}>G</Typography>
//     </Box>
//   );

//   const getNearbyIcon = () => (
//     <Box sx={{ 
//       width: 20, 
//       height: 20, 
//       borderRadius: '50%', 
//       backgroundColor: colors.nearby, 
//       display: 'flex', 
//       alignItems: 'center', 
//       justifyContent: 'center',
//       mr: 1
//     }}>
//       <NearMeIcon sx={{ fontSize: 14, color: 'white' }} />
//     </Box>
//   );

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background, position: "relative" }}>
//       {/* Header */}
//       <AppBar position="sticky" sx={{ backgroundColor: colors.primary, color: "#fff" }}>
//         <Toolbar>
//           <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography variant="h6" sx={{ ml: 2 }}>Property Search</Typography>
//         </Toolbar>
//       </AppBar>

//       {/* Error Snackbar */}
//       <Snackbar open={!!error} autoHideDuration={6000} onClose={handleCloseError}>
//         <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
//           {error}
//         </Alert>
//       </Snackbar>

//       {/* Loading Overlay */}
//       {loading && (
//         <Box sx={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           backgroundColor: 'rgba(255, 255, 255, 0.8)',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           zIndex: 9999
//         }}>
//           <CircularProgress sx={{ color: colors.secondary, mb: 2 }} />
//           <Typography variant="body1" sx={{ color: colors.primary }}>
//             Loading property data...
//           </Typography>
//         </Box>
//       )}

//       {/* Main Content */}
//       <Box sx={{ p: 2, flex: 1 }}>
//         {/* Search Box */}
//         <Box sx={{ position: "relative", mb: 3 }}>
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder="Search for localities, cities, or landmarks..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon sx={{ color: colors.secondary }} />
//                 </InputAdornment>
//               ),
//               endAdornment: isSearching ? (
//                 <InputAdornment position="end">
//                   <CircularProgress size={20} />
//                 </InputAdornment>
//               ) : null
//             }}
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 2,
//                 backgroundColor: '#fff',
//                 '&:hover fieldset': { borderColor: colors.secondary },
//                 '&.Mui-focused fieldset': { borderColor: colors.secondary }
//               }
//             }}
//             onFocus={() => {
//               if (searchQuery.trim() !== "") {
//                 setShowSearchResults(true);
//               }
//             }}
//           />

//           {/* Search Results Dropdown */}
//           {showSearchResults && (
//             <Paper
//               elevation={3}
//               sx={{
//                 position: "absolute",
//                 top: "100%",
//                 left: 0,
//                 right: 0,
//                 zIndex: 1300,
//                 mt: 1,
//                 maxHeight: 500,
//                 overflow: "auto",
//                 border: `1px solid ${colors.secondary}`,
//                 boxShadow: 3
//               }}
//             >
//               {/* No Results Message */}
//               {showNoResults && searchResults.length === 0 && (
//                 <Box sx={{ p: 3, textAlign: 'center' }}>
//                   <WarningIcon sx={{ fontSize: 40, color: colors.warning, mb: 1 }} />
//                   <Typography variant="body1" sx={{ fontWeight: 'medium', color: colors.primary, mb: 0.5 }}>
//                     No properties found
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: 'text.secondary' }}>
//                     No properties available for "{searchQuery}"
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 1 }}>
//                     Try a different location or check back later
//                   </Typography>
//                 </Box>
//               )}

//               {/* API Results Section */}
//               {searchResults.filter(r => r.isFromAPI && !r.isNearby).length > 0 && (
//                 <>
//                   <Box sx={{ p: 1, backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
//                     <Typography variant="caption" sx={{ fontWeight: 'bold', color: colors.primary }}>
//                       PROPERTIES AVAILABLE ({searchResults.filter(r => r.isFromAPI && !r.isNearby).length})
//                     </Typography>
//                   </Box>
//                   <List dense sx={{ py: 0 }}>
//                     {searchResults.filter(r => r.isFromAPI && !r.isNearby).map((result, index) => {
//                       const name = safeGet(result, 'name');
//                       const fullLocation = safeGet(result, 'fullLocation');
//                       const type = safeGet(result, 'type', 'city');
//                       const count = safeGet(result, 'count', 0);
                      
//                       return (
//                         <React.Fragment key={`api-${index}`}>
//                           <ListItem
//                             button
//                             onClick={() => handleSearchResultClick(result)}
//                             sx={{
//                               py: 1.5,
//                               '&:hover': {
//                                 backgroundColor: "rgba(139, 115, 85, 0.1)"
//                               }
//                             }}
//                           >
//                             <ListItemIcon>
//                               {getLocationIcon(type)}
//                             </ListItemIcon>
//                             <ListItemText
//                               primary={
//                                 <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
//                                   {name}
//                                 </Typography>
//                               }
//                               secondary={
//                                 <Box>
//                                   <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
//                                     {fullLocation}
//                                   </Typography>
//                                   <Typography variant="caption" sx={{ 
//                                     color: count > 0 ? colors.secondary : colors.warning,
//                                     fontWeight: 'bold'
//                                   }}>
//                                     {getResultCountText(count)}
//                                   </Typography>
//                                 </Box>
//                               }
//                             />
//                             {count > 0 && (
//                               <Chip
//                                 label={count}
//                                 size="small"
//                                 sx={{
//                                   backgroundColor: colors.secondary,
//                                   color: "#fff",
//                                   fontWeight: 'bold',
//                                   fontSize: '0.75rem',
//                                   minWidth: '30px'
//                                 }}
//                               />
//                             )}
//                           </ListItem>
//                           {index < searchResults.filter(r => r.isFromAPI && !r.isNearby).length - 1 && <Divider />}
//                         </React.Fragment>
//                       );
//                     })}
//                   </List>
//                 </>
//               )}

//               {/* Nearby Locations Section */}
//               {searchResults.filter(r => r.isNearby).length > 0 && (
//                 <>
//                   {searchResults.filter(r => r.isFromAPI && !r.isNearby).length > 0 && <Divider />}
//                   <Box sx={{ p: 1, backgroundColor: '#e3f2fd', borderBottom: '1px solid #bbdefb' }}>
//                     <Typography variant="caption" sx={{ fontWeight: 'bold', color: colors.nearby }}>
//                       NEARBY LOCATIONS WITHIN 5KM ({searchResults.filter(r => r.isNearby).length})
//                     </Typography>
//                   </Box>
//                   <List dense sx={{ py: 0 }}>
//                     {searchResults.filter(r => r.isNearby).map((result, index) => {
//                       const name = safeGet(result, 'name');
//                       const fullLocation = safeGet(result, 'fullLocation');
//                       const type = safeGet(result, 'type', 'city');
//                       const count = safeGet(result, 'count', 0);
//                       const distance = safeGet(result, 'distance', '');
                      
//                       return (
//                         <React.Fragment key={`nearby-${index}`}>
//                           <ListItem
//                             button
//                             onClick={() => handleSearchResultClick(result)}
//                             sx={{
//                               py: 1.5,
//                               '&:hover': {
//                                 backgroundColor: "rgba(25, 118, 210, 0.1)"
//                               }
//                             }}
//                           >
//                             <ListItemIcon>
//                               <NearMeIcon sx={{ color: colors.nearby }} />
//                             </ListItemIcon>
//                             <ListItemText
//                               primary={
//                                 <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
//                                   <Typography variant="body1" sx={{ fontWeight: 'medium', mr: 1 }}>
//                                     {name}
//                                   </Typography>
//                                   <Chip
//                                     label={`${distance} km away`}
//                                     size="small"
//                                     sx={{
//                                       backgroundColor: colors.nearby,
//                                       color: "#fff",
//                                       fontSize: '0.65rem',
//                                       height: '20px',
//                                       '& .MuiChip-label': { px: 1 }
//                                     }}
//                                   />
//                                 </Box>
//                               }
//                               secondary={
//                                 <Box>
//                                   <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
//                                     {fullLocation}
//                                   </Typography>
//                                   <Typography variant="caption" sx={{ 
//                                     color: count > 0 ? colors.secondary : colors.warning,
//                                     fontWeight: 'bold'
//                                   }}>
//                                     {getResultCountText(count)}
//                                   </Typography>
//                                 </Box>
//                               }
//                             />
//                             {count > 0 && (
//                               <Chip
//                                 label={count}
//                                 size="small"
//                                 sx={{
//                                   backgroundColor: colors.nearby,
//                                   color: "#fff",
//                                   fontWeight: 'bold',
//                                   fontSize: '0.75rem',
//                                   minWidth: '30px'
//                                 }}
//                               />
//                             )}
//                           </ListItem>
//                           {index < searchResults.filter(r => r.isNearby).length - 1 && <Divider />}
//                         </React.Fragment>
//                       );
//                     })}
//                   </List>
//                 </>
//               )}

//               {/* Google Maps Results Section */}
//               {searchResults.filter(r => !r.isFromAPI && !r.isNearby).length > 0 && (
//                 <>
//                   {(searchResults.filter(r => r.isFromAPI && !r.isNearby).length > 0 || searchResults.filter(r => r.isNearby).length > 0) && <Divider />}
//                   <Box sx={{ p: 1, backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
//                     <Typography variant="caption" sx={{ fontWeight: 'bold', color: colors.primary }}>
//                       OTHER LOCATIONS ({searchResults.filter(r => !r.isFromAPI && !r.isNearby).length})
//                     </Typography>
//                   </Box>
//                   <List dense sx={{ py: 0 }}>
//                     {searchResults.filter(r => !r.isFromAPI && !r.isNearby).map((result, index) => {
//                       const name = safeGet(result, 'name');
//                       const description = safeGet(result, 'description');
//                       const fullAddress = safeGet(result, 'fullAddress');
                      
//                       return (
//                         <React.Fragment key={`google-${index}`}>
//                           <ListItem
//                             button
//                             onClick={() => handleSearchResultClick(result)}
//                             sx={{
//                               py: 1.5,
//                               '&:hover': {
//                                 backgroundColor: "rgba(66, 133, 244, 0.1)"
//                               }
//                             }}
//                           >
//                             <ListItemAvatar>
//                               {getGoogleMapsIcon()}
//                             </ListItemAvatar>
//                             <ListItemText
//                               primary={
//                                 <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
//                                   {name}
//                                 </Typography>
//                               }
//                               secondary={
//                                 <Typography variant="caption" sx={{ color: 'text.secondary' }}>
//                                   {description || fullAddress}
//                                 </Typography>
//                               }
//                             />
//                             <Typography variant="caption" sx={{ 
//                               color: colors.warning,
//                               fontStyle: 'italic',
//                               fontSize: '0.7rem'
//                             }}>
//                               No properties
//                             </Typography>
//                           </ListItem>
//                           {index < searchResults.filter(r => !r.isFromAPI && !r.isNearby).length - 1 && <Divider />}
//                         </React.Fragment>
//                       );
//                     })}
//                   </List>
//                 </>
//               )}
//             </Paper>
//           )}
//         </Box>

//         {/* Use Current Location */}
//         <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={useCurrentLocation}
//                 onChange={handleUseCurrentLocation}
//                 sx={{ color: colors.secondary }}
//               />
//             }
//             label="Use my current location"
//           />
//           {useCurrentLocation && isSearching && (
//             <CircularProgress size={20} sx={{ color: colors.secondary }} />
//           )}
//         </Box>

//         {/* Add Locations Section */}
//         <Box sx={{ mb: 3 }}>
//           <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
//             Add Locations (Max 3)
//           </Typography>
          
//           {/* Selected Locations Chips */}
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
//             {selectedLocations.map((location, index) => {
//               const name = safeGet(location, 'name');
//               const count = safeGet(location, 'count', 0);
//               const type = safeGet(location, 'type');
              
//               return (
//                 <Chip
//                   key={index}
//                   icon={getLocationIcon(type)}
//                   label={`${name} ${count > 0 ? `(${count})` : ''}`}
//                   onDelete={() => handleLocationRemove(location)}
//                   sx={{
//                     backgroundColor: location.isNearby ? colors.nearby : colors.secondary,
//                     color: "#fff",
//                     fontWeight: 'bold',
//                     '& .MuiChip-icon': {
//                       color: "#fff !important"
//                     },
//                     '& .MuiChip-deleteIcon': {
//                       color: "#fff"
//                     }
//                   }}
//                 />
//               );
//             })}
//             {selectedLocations.length < 3 && (
//               <Chip
//                 label="Add Location"
//                 onClick={() => setLocationDialogOpen(true)}
//                 variant="outlined"
//                 deleteIcon={<AddIcon />}
//                 onDelete={() => setLocationDialogOpen(true)}
//                 sx={{
//                   borderColor: colors.secondary,
//                   color: colors.secondary,
//                   '& .MuiChip-deleteIcon': {
//                     color: colors.secondary
//                   }
//                 }}
//               />
//             )}
//           </Box>

//           {/* Popular Cities with counts */}
//           <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
//             Popular Cities in India
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//             {popularCities.map((city, index) => {
//               // Find matching cities in API data
//               const matchingCities = apiData.filter(item => {
//                 const itemName = safeGet(item, 'name', '').toLowerCase();
//                 const itemLocation = safeGet(item, 'fullLocation', '').toLowerCase();
//                 const itemCity = safeGet(item, 'city', '').toLowerCase();
                
//                 return (
//                   itemName.includes(city.toLowerCase()) ||
//                   itemLocation.includes(city.toLowerCase()) ||
//                   itemCity.includes(city.toLowerCase())
//                 );
//               });
              
//               const totalCount = matchingCities.reduce((sum, item) => sum + (item.count || 0), 0);
              
//               return (
//                 <Chip
//                   key={index}
//                   label={`${city} ${totalCount > 0 ? `(${totalCount})` : ''}`}
//                   onClick={() => {
//                     if (matchingCities.length > 0) {
//                       // Select the first matching city with highest count
//                       const bestMatch = matchingCities.reduce((prev, current) => 
//                         (prev.count || 0) > (current.count || 0) ? prev : current
//                       );
//                       handleLocationSelect(bestMatch);
//                     } else {
//                       handleLocationSelect({ 
//                         name: city, 
//                         type: 'city', 
//                         count: 0,
//                         fullLocation: city
//                       });
//                     }
//                   }}
//                   variant="outlined"
//                   sx={{
//                     borderColor: totalCount > 0 ? colors.secondary : '#ccc',
//                     color: totalCount > 0 ? colors.secondary : '#666',
//                     fontWeight: 'bold',
//                     '&:hover': {
//                       backgroundColor: totalCount > 0 ? colors.secondary : '#f0f0f0',
//                       color: totalCount > 0 ? "#fff" : '#666'
//                     }
//                   }}
//                 />
//               );
//             })}
//           </Box>
//         </Box>

//         {/* Property Type Filter */}
//         <Box sx={{ mb: 3 }}>
//           <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
//             Property Type
//           </Typography>
//           <Chip
//             label={selectedPropertyTypes.length > 0 ? `${selectedPropertyTypes.length} selected` : "Select Property Types"}
//             onClick={() => setPropertyTypeDialogOpen(true)}
//             variant="outlined"
//             deleteIcon={<AddIcon />}
//             onDelete={() => setPropertyTypeDialogOpen(true)}
//             sx={{
//               borderColor: colors.secondary,
//               color: colors.secondary,
//               '& .MuiChip-deleteIcon': {
//                 color: colors.secondary
//               }
//             }}
//           />
//           {selectedPropertyTypes.length > 0 && (
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
//               {selectedPropertyTypes.map((type, index) => (
//                 <Chip
//                   key={index}
//                   label={type}
//                   onDelete={() => handlePropertyTypeSelect(type)}
//                   sx={{
//                     backgroundColor: colors.secondary,
//                     color: "#fff",
//                     '& .MuiChip-deleteIcon': {
//                       color: "#fff"
//                     }
//                   }}
//                 />
//               ))}
//             </Box>
//           )}
//         </Box>

//         {/* Tabs Section */}
//         <Box sx={{ mb: 4, backgroundColor: '#fff', borderRadius: 2, overflow: 'hidden', border: '1px solid #e0e0e0' }}>
//           <Typography variant="h6" sx={{ p: 2, fontWeight: 'bold', color: colors.primary, borderBottom: '1px solid #e0e0e0' }}>
//             Looking For
//           </Typography>
//           <Tabs 
//             value={activeTab} 
//             onChange={handleTabChange} 
//             variant="scrollable" 
//             scrollButtons="auto"
//             sx={{ 
//               '& .MuiTab-root': { 
//                 fontSize: '0.8rem', 
//                 fontWeight: 'bold', 
//                 color: colors.primary, 
//                 minWidth: 'auto', 
//                 px: 2, 
//                 py: 1.5,
//                 '&.Mui-selected': { color: colors.secondary } 
//               }, 
//               '& .MuiTabs-indicator': { backgroundColor: colors.secondary } 
//             }}
//           >
//             {filterTabs.map((tab, index) => (
//               <Tab key={index} label={tab.label} />
//             ))}
//           </Tabs>
//           <Box sx={{ p: 2, backgroundColor: '#f9f9f9', borderTop: '1px solid #e0e0e0' }}>
//             <Typography variant="body2" sx={{ color: colors.primary, fontStyle: 'italic' }}>
//               Selected: <strong>{filterTabs[activeTab]?.label || "None"}</strong>
//             </Typography>
//           </Box>
//         </Box>

//         {/* Stats Display */}
//         {apiData.length > 0 && (
//           <Box sx={{ mb: 3, p: 2, backgroundColor: '#fff', borderRadius: 2, border: `1px solid ${colors.secondary}` }}>
//             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: colors.primary, mb: 1 }}>
//               Property Search Summary
//             </Typography>
//             <Typography variant="body2" sx={{ color: colors.primary, mb: 0.5 }}>
//               • Total locations with properties: <strong>{apiData.length}</strong>
//             </Typography>
//             <Typography variant="body2" sx={{ color: colors.primary, mb: 0.5 }}>
//               • Total properties available: <strong>{apiData.reduce((sum, item) => sum + (item.count || 0), 0)}</strong>
//             </Typography>
//             {nearbyLocations.length > 0 && (
//               <Typography variant="body2" sx={{ color: colors.nearby, mb: 0.5 }}>
//                 • Nearby locations found: <strong>{nearbyLocations.length} within 5km</strong>
//               </Typography>
//             )}
//             <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 1 }}>
//               Data loaded from your property requests
//             </Typography>
//           </Box>
//         )}

//         {/* Apply Button */}
//         <Button
//           variant="contained"
//           fullWidth
//           onClick={handleApplyFilters}
//           sx={{
//             backgroundColor: colors.secondary,
//             color: "#fff",
//             py: 1.5,
//             fontSize: '1rem',
//             fontWeight: 'bold',
//             borderRadius: 2,
//             '&:hover': {
//               backgroundColor: "#A52A2A"
//             }
//           }}
//         >
//           Apply
//         </Button>
//       </Box>

//       {/* Location Dialog */}
//       <Dialog open={locationDialogOpen} onClose={() => setLocationDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Add Locations</Typography>
//             <IconButton onClick={() => setLocationDialogOpen(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={useCurrentLocation}
//                 onChange={handleUseCurrentLocation}
//                 sx={{ color: colors.secondary }}
//               />
//             }
//             label="Use my current location"
//           />
//           <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
//             Selected Locations ({selectedLocations.length}/3)
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
//             {selectedLocations.map((location, index) => {
//               const name = safeGet(location, 'name');
//               const count = safeGet(location, 'count', 0);
              
//               return (
//                 <Chip
//                   key={index}
//                   label={`${name} ${count > 0 ? `(${count})` : ''}`}
//                   onDelete={() => handleLocationRemove(location)}
//                   sx={{
//                     backgroundColor: colors.secondary,
//                     color: "#fff",
//                     '& .MuiChip-deleteIcon': {
//                       color: "#fff"
//                     }
//                   }}
//                 />
//               );
//             })}
//           </Box>
//           <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
//             Popular Cities in India
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//             {popularCities.map((city, index) => {
//               const matchingCities = apiData.filter(item => {
//                 const itemName = safeGet(item, 'name', '').toLowerCase();
//                 const itemLocation = safeGet(item, 'fullLocation', '').toLowerCase();
//                 return itemName.includes(city.toLowerCase()) || itemLocation.includes(city.toLowerCase());
//               });
              
//               const totalCount = matchingCities.reduce((sum, item) => sum + (item.count || 0), 0);
              
//               return (
//                 <Chip
//                   key={index}
//                   label={`${city} ${totalCount > 0 ? `(${totalCount})` : ''}`}
//                   onClick={() => {
//                     if (matchingCities.length > 0) {
//                       const bestMatch = matchingCities.reduce((prev, current) => 
//                         (prev.count || 0) > (current.count || 0) ? prev : current
//                       );
//                       handleLocationSelect(bestMatch);
//                     } else {
//                       handleLocationSelect({ 
//                         name: city, 
//                         type: 'city', 
//                         count: 0,
//                         fullLocation: city
//                       });
//                     }
//                   }}
//                   variant="outlined"
//                   sx={{
//                     borderColor: totalCount > 0 ? colors.secondary : '#ccc',
//                     color: totalCount > 0 ? colors.secondary : '#666',
//                     '&:hover': {
//                       backgroundColor: totalCount > 0 ? colors.secondary : '#f0f0f0',
//                       color: totalCount > 0 ? "#fff" : '#666'
//                     }
//                   }}
//                 />
//               );
//             })}
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button
//             onClick={() => setLocationDialogOpen(false)}
//             variant="contained"
//             fullWidth
//             sx={{
//               backgroundColor: colors.secondary,
//               color: "#fff",
//               '&:hover': { backgroundColor: "#A52A2A" }
//             }}
//           >
//             Done ({selectedLocations.length}/3 selected)
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Property Type Dialog */}
//       <Dialog open={propertyTypeDialogOpen} onClose={() => setPropertyTypeDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">Select Property Type</Typography>
//             <IconButton onClick={() => setPropertyTypeDialogOpen(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
//             Select one or more property types
//           </Typography>
//           <List>
//             {propertyTypes.map((type, index) => (
//               <ListItem
//                 key={index}
//                 button
//                 onClick={() => handlePropertyTypeSelect(type)}
//                 sx={{
//                   borderBottom: '1px solid #e0e0e0',
//                   '&:last-child': { borderBottom: 'none' },
//                   '&:hover': {
//                     backgroundColor: "rgba(139, 115, 85, 0.1)"
//                   }
//                 }}
//               >
//                 <Checkbox
//                   checked={selectedPropertyTypes.includes(type)}
//                   sx={{ color: colors.secondary }}
//                 />
//                 <ListItemText 
//                   primary={type} 
//                   primaryTypographyProps={{ fontWeight: 'medium' }}
//                 />
//               </ListItem>
//             ))}
//           </List>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button
//             onClick={() => setPropertyTypeDialogOpen(false)}
//             variant="contained"
//             fullWidth
//             sx={{
//               backgroundColor: colors.secondary,
//               color: "#fff",
//               '&:hover': { backgroundColor: "#A52A2A" }
//             }}
//           >
//             Select ({selectedPropertyTypes.length} chosen)
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default PropertySearchFilters;



import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  TextField,
  Chip,
  Checkbox,
  FormControlLabel,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  InputAdornment,
  Tabs,
  Tab,
  Paper,
  Divider,
  CircularProgress,
  Alert,
  Snackbar,
  Avatar,
  ListItemAvatar
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ApartmentIcon from "@mui/icons-material/Apartment";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import WarningIcon from "@mui/icons-material/Warning";
import NearMeIcon from "@mui/icons-material/NearMe";
import { useNavigate } from "react-router-dom";
import { popularCities, propertyTypes, tabs as filterTabs } from "./propertyFilters";
import { GOOGLEMAPS_API_KEY } from './../../Api/ApiUrls';

const GOOGLE_MAPS_API_KEY = GOOGLEMAPS_API_KEY;
const API_ENDPOINT = "https://landnest.net:81/property-request/";

const PropertySearchFilters = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [useCurrentLocation, setUseCurrentLocation] = useState(false);
  const [propertyTypeDialogOpen, setPropertyTypeDialogOpen] = useState(false);
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
  const [locationDialogOpen, setLocationDialogOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [googleMapsResults, setGoogleMapsResults] = useState([]);
  const [showNoResults, setShowNoResults] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [nearbyLocations, setNearbyLocations] = useState([]);
  const [selectedLocationCoordinates, setSelectedLocationCoordinates] = useState(null);
  const searchTimeoutRef = useRef(null);
  const [searchCache, setSearchCache] = useState({});

  const colors = {
    primary: "#1a1a1a",
    secondary: "#8B7355",
    background: "#f5f5f5",
    warning: "#ff9800",
    error: "#f44336",
    nearby: "#388e3c",
    exact: "#1976d2",
    google: "#f57c00"
  };

  // Calculate distance between two coordinates using Haversine formula
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Earth's radius in kilometers
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c; // Distance in kilometers
  };

  // Find nearby locations within 5km radius
  const findNearbyLocations = (centerLat, centerLng, allLocations) => {
    if (!centerLat || !centerLng || !allLocations || !Array.isArray(allLocations)) {
      return [];
    }

    const MAX_DISTANCE_KM = 5; // 5 kilometers radius
    
    return allLocations.filter(location => {
      if (!location.lat || !location.long) return false;
      
      const distance = calculateDistance(
        centerLat, centerLng,
        parseFloat(location.lat), parseFloat(location.long)
      );
      
      return distance <= MAX_DISTANCE_KM;
    });
  };

  // Fetch API data on component mount
  useEffect(() => {
    fetchPropertyRequests();
  }, []);

  const fetchPropertyRequests = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(API_ENDPOINT, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!Array.isArray(data)) {
        throw new Error('API response is not an array');
      }
      
      const processedData = processApiData(data);
      setApiData(processedData);
      
      localStorage.setItem('propertyRequestsCache', JSON.stringify(processedData));
      
    } catch (err) {
      console.error('Error fetching property requests:', err);
      setError(`Failed to load property data: ${err.message}`);
      
      const cachedData = localStorage.getItem('propertyRequestsCache');
      if (cachedData) {
        try {
          setApiData(JSON.parse(cachedData));
        } catch (parseError) {
          console.error('Error parsing cached data:', parseError);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  // Process API data to extract searchable locations and counts
  const processApiData = (data) => {
    if (!Array.isArray(data)) return [];
    
    const locationMap = new Map();
    
    data.forEach(request => {
      if (request && request.pro_loc && Array.isArray(request.pro_loc)) {
        request.pro_loc.forEach(location => {
          const locName = location?.location || '';
          if (locName && typeof locName === 'string') {
            const nameParts = locName.split(',');
            const primaryName = nameParts.length > 0 ? nameParts[0].trim() : locName.trim();
            const cityName = nameParts.length > 1 ? nameParts[1].trim() : primaryName;
            
            if (locationMap.has(locName)) {
              const existing = locationMap.get(locName);
              locationMap.set(locName, {
                ...existing,
                count: existing.count + 1,
                requests: [...(existing.requests || []), request.req_id]
              });
            } else {
              locationMap.set(locName, {
                name: primaryName,
                fullLocation: locName,
                city: cityName,
                type: determineLocationType(locName),
                count: 1,
                requests: [request.req_id],
                lat: location?.lat ? parseFloat(location.lat) : null,
                long: location?.long ? parseFloat(location.long) : null,
                isFromAPI: true,
                propertiesCount: 1
              });
            }
          }
        });
      }
    });
    
    return Array.from(locationMap.values());
  };

  // Determine location type based on the location string
  const determineLocationType = (location) => {
    if (!location || typeof location !== 'string') return "city";
    
    const locLower = location.toLowerCase();
    if (locLower.includes('layout') || locLower.includes('colony') || locLower.includes('nagar') || 
        locLower.includes('society') || locLower.includes('village') || locLower.includes('town')) {
      return "locality";
    } else if (locLower.includes('apartment') || locLower.includes('towers') || locLower.includes('heights') ||
               locLower.includes('complex') || locLower.includes('residency') || locLower.includes('estate')) {
      return "project";
    } else if (locLower.includes('street') || locLower.includes('road') || locLower.includes('lane') ||
               locLower.includes('avenue') || locLower.includes('boulevard')) {
      return "address";
    } else {
      return "city";
    }
  };

  // Search Google Maps API for locations
  const searchGoogleMaps = useCallback(async (query) => {
    if (!query.trim() || !GOOGLE_MAPS_API_KEY) {
      setGoogleMapsResults([]);
      return [];
    }

    // Check cache first
    if (searchCache[query]) {
      return searchCache[query];
    }

    try {
      const encodedQuery = encodeURIComponent(query);
      const url = `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${encodedQuery}&key=${GOOGLE_MAPS_API_KEY}&components=country:in`;
      
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.status === 'OK' && data.predictions) {
        // For each prediction, fetch place details to get coordinates
        const results = await Promise.all(
          data.predictions.slice(0, 3).map(async (prediction) => {
            try {
              // Get place details for coordinates
              const detailsUrl = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${prediction.place_id}&fields=geometry,name,formatted_address&key=${GOOGLE_MAPS_API_KEY}`;
              const detailsResponse = await fetch(detailsUrl);
              const detailsData = await detailsResponse.json();
              
              const result = {
                id: prediction.place_id,
                name: prediction.structured_formatting.main_text,
                description: prediction.structured_formatting.secondary_text || '',
                fullAddress: prediction.description,
                type: 'google',
                isFromGoogle: true,
                lat: detailsData.result?.geometry?.location?.lat,
                lng: detailsData.result?.geometry?.location?.lng
              };
              
              // Cache the result
              setSearchCache(prev => ({
                ...prev,
                [query]: [...(prev[query] || []), result]
              }));
              
              return result;
            } catch (error) {
              console.error('Error fetching place details:', error);
              const result = {
                id: prediction.place_id,
                name: prediction.structured_formatting.main_text,
                description: prediction.structured_formatting.secondary_text || '',
                fullAddress: prediction.description,
                type: 'google',
                isFromGoogle: true
              };
              
              // Cache even without coordinates
              setSearchCache(prev => ({
                ...prev,
                [query]: [...(prev[query] || []), result]
              }));
              
              return result;
            }
          })
        );
        setGoogleMapsResults(results);
        return results;
      } else {
        setGoogleMapsResults([]);
        return [];
      }
    } catch (error) {
      console.error('Error searching Google Maps:', error);
      setGoogleMapsResults([]);
      return [];
    }
  }, [GOOGLE_MAPS_API_KEY, searchCache]);

  // Get current location using browser geolocation
  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser");
      return;
    }

    setIsSearching(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        setCurrentLocation({ lat: latitude, lng: longitude });
        
        try {
          // Reverse geocode to get location name
          const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`;
          const response = await fetch(url);
          const data = await response.json();
          
          if (data.status === 'OK' && data.results[0]) {
            const locationName = data.results[0].formatted_address;
            const locationData = {
              name: "My Current Location",
              fullLocation: locationName,
              type: "current",
              lat: latitude,
              long: longitude,
              isCurrentLocation: true,
              count: 0
            };
            
            handleLocationSelect(locationData);
            
            // Find nearby locations for current location
            const nearby = findNearbyLocations(latitude, longitude, apiData)
              .map(location => ({
                ...location,
                isNearby: true,
                distance: calculateDistance(
                  latitude,
                  longitude,
                  parseFloat(location.lat),
                  parseFloat(location.long)
                ).toFixed(1)
              }));
            setNearbyLocations(nearby);
          }
        } catch (error) {
          console.error('Error reverse geocoding:', error);
        } finally {
          setIsSearching(false);
        }
      },
      (error) => {
        console.error('Error getting location:', error);
        setError("Unable to get your current location");
        setIsSearching(false);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  };

  // Debounced search with API and Google Maps
  useEffect(() => {
    if (searchQuery.trim() === "") {
      setSearchResults([]);
      setGoogleMapsResults([]);
      setNearbyLocations([]);
      setShowSearchResults(false);
      setShowNoResults(false);
      return;
    }

    setIsSearching(true);
    setShowNoResults(false);
    setNearbyLocations([]);

    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(async () => {
      try {
        const queryLower = searchQuery.toLowerCase().trim();
        
        // 1. Search in API data for exact matches
        const apiResults = searchInApiData(queryLower);
        
        // 2. Search Google Maps for location suggestions
        let googleResults = [];
        let searchLocationCoords = null;
        
        if (GOOGLE_MAPS_API_KEY && queryLower.length >= 2) {
          googleResults = await searchGoogleMaps(searchQuery);
          
          // If we get Google results, get coordinates of the first result
          if (googleResults.length > 0 && googleResults[0].lat && googleResults[0].lng) {
            searchLocationCoords = {
              lat: googleResults[0].lat,
              lng: googleResults[0].lng
            };
          }
        }
        
        // 3. If we have API results with coordinates, use those for nearby search
        if (apiResults.length > 0 && !searchLocationCoords) {
          const apiResultWithCoords = apiResults.find(r => r.lat && r.long);
          if (apiResultWithCoords) {
            searchLocationCoords = {
              lat: apiResultWithCoords.lat,
              lng: apiResultWithCoords.long
            };
          }
        }
        
        // 4. Find nearby locations (within 5km) for the search location
        let nearbyResults = [];
        if (searchLocationCoords) {
          nearbyResults = findNearbyLocations(
            searchLocationCoords.lat,
            searchLocationCoords.lng,
            apiData
          )
          .filter(nearbyLocation => {
            // Exclude exact matches from nearby results (they'll be shown separately)
            const isExactMatch = apiResults.some(exactMatch => 
              exactMatch.fullLocation === nearbyLocation.fullLocation
            );
            return !isExactMatch;
          })
          .map(location => ({
            ...location,
            isNearby: true,
            distance: calculateDistance(
              searchLocationCoords.lat,
              searchLocationCoords.lng,
              location.lat,
              location.long
            ).toFixed(1)
          }))
          .sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance)); // Sort by closest first
        }
        
        // 5. Create categorized results array
        const categorizedResults = [
          // Exact matches from API
          ...apiResults.map(result => ({
            ...result,
            category: 'exact',
            section: 'EXACT MATCHES'
          })),
          
          // Nearby locations
          ...nearbyResults.map(result => ({
            ...result,
            category: 'nearby',
            section: 'NEARBY WITHIN 5KM'
          })),
          
          // Google Maps results
          ...googleResults.map(result => ({
            ...result,
            category: 'google',
            section: 'LOCATION SUGGESTIONS'
          }))
        ];
        
        setSearchResults(categorizedResults);
        setNearbyLocations(nearbyResults);
        setShowSearchResults(true);
        setShowNoResults(categorizedResults.length === 0);
        
      } catch (error) {
        console.error('Search error:', error);
        setSearchResults([]);
        setShowNoResults(true);
      } finally {
        setIsSearching(false);
      }
    }, 500);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchQuery, apiData, searchGoogleMaps]);

  const searchInApiData = (queryLower) => {
    if (!apiData || !Array.isArray(apiData) || apiData.length === 0) {
      return [];
    }

    // Search in multiple fields with different matching strategies
    const exactMatches = [];
    const partialMatches = [];
    
    apiData.forEach(item => {
      if (!item) return;
      
      const name = (item.name || '').toLowerCase();
      const fullLocation = (item.fullLocation || '').toLowerCase();
      const city = (item.city || '').toLowerCase();
      
      // Check for exact matches
      if (name === queryLower || fullLocation === queryLower) {
        exactMatches.push(item);
      } 
      // Check for partial matches
      else if (name.includes(queryLower) || 
               fullLocation.includes(queryLower) || 
               city.includes(queryLower)) {
        partialMatches.push(item);
      }
    });

    // Sort exact matches by count (highest first)
    exactMatches.sort((a, b) => (b.count || 0) - (a.count || 0));
    
    // Sort partial matches by relevance and count
    partialMatches.sort((a, b) => {
      // Priority: name matches > fullLocation matches > city matches
      const aNameMatch = (a.name || '').toLowerCase().includes(queryLower);
      const bNameMatch = (b.name || '').toLowerCase().includes(queryLower);
      
      if (aNameMatch && !bNameMatch) return -1;
      if (!aNameMatch && bNameMatch) return 1;
      
      // Then by count
      return (b.count || 0) - (a.count || 0);
    });

    return [...exactMatches, ...partialMatches];
  };

  const handleLocationSelect = (location) => {
    if (!location || !location.name) return;
    
    if (selectedLocations.length < 3 && !selectedLocations.some(loc => loc.name === location.name)) {
      setSelectedLocations([...selectedLocations, location]);
      setSearchQuery("");
      setShowSearchResults(false);
      setShowNoResults(false);
      
      // If location has coordinates, find nearby locations
      if (location.lat && location.long) {
        const nearby = findNearbyLocations(
          location.lat,
          location.long,
          apiData
        ).map(loc => ({
          ...loc,
          isNearby: true,
          distance: calculateDistance(
            location.lat,
            location.long,
            loc.lat,
            loc.long
          ).toFixed(1)
        }));
        setNearbyLocations(nearby);
      }
    }
  };

  const handleLocationRemove = (locationToRemove) => {
    if (!locationToRemove || !locationToRemove.name) return;
    
    setSelectedLocations(selectedLocations.filter(location => 
      location?.name !== locationToRemove.name
    ));
    
    // If removing current location, update the checkbox
    if (locationToRemove.name === "My Current Location") {
      setUseCurrentLocation(false);
    }
  };

  const handlePropertyTypeSelect = (type) => {
    if (selectedPropertyTypes.includes(type)) {
      setSelectedPropertyTypes(selectedPropertyTypes.filter(t => t !== type));
    } else {
      setSelectedPropertyTypes([...selectedPropertyTypes, type]);
    }
  };

  const handleUseCurrentLocation = () => {
    const newUseCurrentLocation = !useCurrentLocation;
    setUseCurrentLocation(newUseCurrentLocation);
    
    if (newUseCurrentLocation) {
      getCurrentLocation();
    } else {
      // Remove current location if it exists
      setSelectedLocations(selectedLocations.filter(loc => 
        loc?.name !== "My Current Location"
      ));
      setNearbyLocations([]);
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleApplyFilters = () => {
    // Navigate to results page with filter parameters
    navigate('/property-results', {
      state: {
        filters: {
          searchQuery,
          selectedLocations,
          selectedPropertyTypes,
          useCurrentLocation,
          activeTab: activeTab,
          nearbyLocations: nearbyLocations
        }
      }
    });
  };

  const handleSearchResultClick = (result) => {
    handleLocationSelect(result);
  };

  const getLocationIcon = (type, category) => {
    if (!type) return <LocationOnIcon sx={{ color: colors.secondary }} />;
    
    // Override based on category
    if (category === 'nearby') return <NearMeIcon sx={{ color: colors.nearby }} />;
    if (category === 'exact') return <LocationOnIcon sx={{ color: colors.exact }} />;
    if (category === 'google') {
      return (
        <Box sx={{ 
          width: 20, 
          height: 20, 
          borderRadius: '50%', 
          backgroundColor: colors.google, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          mr: 1
        }}>
          <Typography variant="caption" sx={{ color: 'white', fontWeight: 'bold' }}>G</Typography>
        </Box>
      );
    }
    
    switch (type) {
      case "city":
        return <LocationOnIcon sx={{ color: colors.exact }} />;
      case "locality":
        return <HomeWorkIcon sx={{ color: "#388e3c" }} />;
      case "project":
        return <ApartmentIcon sx={{ color: "#7b1fa2" }} />;
      case "address":
        return <LocationOnIcon sx={{ color: colors.google }} />;
      case "current":
        return <MyLocationIcon sx={{ color: "#4CAF50" }} />;
      default:
        return <LocationOnIcon sx={{ color: colors.secondary }} />;
    }
  };

  const handleCloseError = () => {
    setError(null);
  };

  const safeGet = (obj, property, defaultValue = '') => {
    return obj && obj[property] !== undefined ? obj[property] : defaultValue;
  };

  const getResultCountText = (count) => {
    if (count === 0) return "No properties";
    if (count === 1) return "1 property";
    return `${count} properties`;
  };

  // Group results by section
  const getResultsBySection = () => {
    const sections = {};
    
    searchResults.forEach(result => {
      const section = result.section || 'OTHER';
      if (!sections[section]) {
        sections[section] = [];
      }
      sections[section].push(result);
    });
    
    return sections;
  };

  // Get section color
  const getSectionColor = (section) => {
    switch (section) {
      case 'EXACT MATCHES':
        return colors.exact;
      case 'NEARBY WITHIN 5KM':
        return colors.nearby;
      case 'LOCATION SUGGESTIONS':
        return colors.google;
      default:
        return colors.primary;
    }
  };

  // Get section background color
  const getSectionBgColor = (section) => {
    switch (section) {
      case 'EXACT MATCHES':
        return '#f0f7ff';
      case 'NEARBY WITHIN 5KM':
        return '#e8f5e9';
      case 'LOCATION SUGGESTIONS':
        return '#fff3e0';
      default:
        return '#f5f5f5';
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background, position: "relative" }}>
      {/* Header */}
      <AppBar position="sticky" sx={{ backgroundColor: colors.primary, color: "#fff" }}>
        <Toolbar>
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2 }}>Property Search</Typography>
        </Toolbar>
      </AppBar>

      {/* Error Snackbar */}
      <Snackbar open={!!error} autoHideDuration={6000} onClose={handleCloseError}>
        <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>

      {/* Loading Overlay */}
      {loading && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <CircularProgress sx={{ color: colors.secondary, mb: 2 }} />
          <Typography variant="body1" sx={{ color: colors.primary }}>
            Loading property data...
          </Typography>
        </Box>
      )}

      {/* Main Content */}
      <Box sx={{ p: 2, flex: 1 }}>
        {/* Search Box */}
        <Box sx={{ position: "relative", mb: 3 }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search for localities, cities, or landmarks..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={() => {
              if (searchQuery.trim() !== "") {
                setShowSearchResults(true);
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: colors.secondary }} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {isSearching ? (
                    <CircularProgress size={20} />
                  ) : searchQuery ? (
                    <IconButton
                      size="small"
                      onClick={() => setSearchQuery("")}
                      sx={{ p: 0 }}
                    >
                      <CloseIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  ) : null}
                </InputAdornment>
              )
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                backgroundColor: '#fff',
                '&:hover fieldset': { borderColor: colors.secondary },
                '&.Mui-focused fieldset': { borderColor: colors.secondary }
              }
            }}
          />

          {/* Search Results Dropdown */}
          {showSearchResults && searchQuery.trim() !== "" && (
            <Paper
              elevation={3}
              sx={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                zIndex: 1300,
                mt: 1,
                maxHeight: 500,
                overflow: "auto",
                border: `1px solid ${colors.secondary}`,
                boxShadow: 3
              }}
            >
              {/* No Results Message */}
              {showNoResults && searchResults.length === 0 && (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <WarningIcon sx={{ fontSize: 40, color: colors.warning, mb: 1 }} />
                  <Typography variant="body1" sx={{ fontWeight: 'medium', color: colors.primary, mb: 0.5 }}>
                    No properties found
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    No properties available for "{searchQuery}"
                  </Typography>
                </Box>
              )}

              {/* Grouped Results */}
              {Object.entries(getResultsBySection()).map(([section, sectionResults], sectionIndex) => (
                <React.Fragment key={section}>
                  {/* Section Header */}
                  <Box sx={{ 
                    p: 1, 
                    backgroundColor: getSectionBgColor(section),
                    borderBottom: `1px solid ${getSectionColor(section)}33`
                  }}>
                    <Typography variant="caption" sx={{ fontWeight: 'bold', color: getSectionColor(section) }}>
                      {section} ({sectionResults.length})
                    </Typography>
                    {section === 'NEARBY WITHIN 5KM' && (
                      <Typography variant="caption" sx={{ color: getSectionColor(section), ml: 1, fontStyle: 'italic' }}>
                        (from your search location)
                      </Typography>
                    )}
                  </Box>

                  {/* Section Results */}
                  <List dense sx={{ py: 0 }}>
                    {sectionResults.map((result, resultIndex) => (
                      <React.Fragment key={`${section}-${resultIndex}`}>
                        <ListItem
                          button
                          onClick={() => handleSearchResultClick(result)}
                          sx={{
                            py: 1.5,
                            '&:hover': { 
                              backgroundColor: `${getSectionColor(result.section)}11` 
                            }
                          }}
                        >
                          <ListItemIcon>
                            {getLocationIcon(result.type, result.category)}
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}>
                                <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                                  {safeGet(result, 'name')}
                                </Typography>
                                {result.distance && (
                                  <Chip
                                    label={`${result.distance} km`}
                                    size="small"
                                    sx={{
                                      backgroundColor: colors.nearby,
                                      color: "#fff",
                                      fontSize: '0.65rem',
                                      height: '18px',
                                      '& .MuiChip-label': { px: 0.5 }
                                    }}
                                  />
                                )}
                              </Box>
                            }
                            secondary={
                              <Box>
                                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
                                  {safeGet(result, 'fullLocation') || safeGet(result, 'description') || safeGet(result, 'fullAddress')}
                                </Typography>
                                {result.count !== undefined && (
                                  <Typography variant="caption" sx={{ 
                                    color: result.count > 0 ? getSectionColor(section) : colors.warning,
                                    fontWeight: 'bold'
                                  }}>
                                    {getResultCountText(result.count)}
                                  </Typography>
                                )}
                              </Box>
                            }
                          />
                          {result.count > 0 ? (
                            <Chip
                              label={result.count}
                              size="small"
                              sx={{
                                backgroundColor: getSectionColor(section),
                                color: "#fff",
                                fontWeight: 'bold',
                                fontSize: '0.75rem',
                                minWidth: '30px'
                              }}
                            />
                          ) : result.category === 'google' && (
                            <Typography variant="caption" sx={{ 
                              color: colors.google,
                              fontStyle: 'italic',
                              fontSize: '0.7rem'
                            }}>
                              Search here
                            </Typography>
                          )}
                        </ListItem>
                        {resultIndex < sectionResults.length - 1 && <Divider />}
                      </React.Fragment>
                    ))}
                  </List>

                  {/* Add divider between sections except after last */}
                  {sectionIndex < Object.keys(getResultsBySection()).length - 1 && <Divider />}
                </React.Fragment>
              ))}

              {/* Help Text if no exact matches but have nearby */}
              {getResultsBySection()['EXACT MATCHES']?.length === 0 && 
               getResultsBySection()['NEARBY WITHIN 5KM']?.length > 0 && (
                <Box sx={{ p: 2, backgroundColor: '#f9f9f9', borderTop: '1px solid #e0e0e0' }}>
                  <Typography variant="caption" sx={{ color: colors.nearby, fontStyle: 'italic' }}>
                    No exact matches found, but showing nearby locations within 5km
                  </Typography>
                </Box>
              )}
            </Paper>
          )}
        </Box>

        {/* Use Current Location */}
        <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={useCurrentLocation}
                onChange={handleUseCurrentLocation}
                sx={{ color: colors.secondary }}
              />
            }
            label="Use my current location"
          />
          {useCurrentLocation && isSearching && (
            <CircularProgress size={20} sx={{ color: colors.secondary }} />
          )}
        </Box>

        {/* Add Locations Section */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
            Add Locations (Max 3)
          </Typography>
          
          {/* Selected Locations Chips */}
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
            {selectedLocations.map((location, index) => {
              const name = safeGet(location, 'name');
              const count = safeGet(location, 'count', 0);
              const type = safeGet(location, 'type');
              
              return (
                <Chip
                  key={index}
                  icon={getLocationIcon(type)}
                  label={`${name} ${count > 0 ? `(${count})` : ''}`}
                  onDelete={() => handleLocationRemove(location)}
                  sx={{
                    backgroundColor: location.isNearby ? colors.nearby : colors.secondary,
                    color: "#fff",
                    fontWeight: 'bold',
                    '& .MuiChip-icon': {
                      color: "#fff !important"
                    },
                    '& .MuiChip-deleteIcon': {
                      color: "#fff"
                    }
                  }}
                />
              );
            })}
            {selectedLocations.length < 3 && (
              <Chip
                label="Add Location"
                onClick={() => setLocationDialogOpen(true)}
                variant="outlined"
                deleteIcon={<AddIcon />}
                onDelete={() => setLocationDialogOpen(true)}
                sx={{
                  borderColor: colors.secondary,
                  color: colors.secondary,
                  '& .MuiChip-deleteIcon': {
                    color: colors.secondary
                  }
                }}
              />
            )}
          </Box>

          {/* Popular Cities with counts */}
          {/* <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
            Popular Cities in India
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {popularCities.map((city, index) => {
              // Find matching cities in API data
              const matchingCities = apiData.filter(item => {
                const itemName = safeGet(item, 'name', '').toLowerCase();
                const itemLocation = safeGet(item, 'fullLocation', '').toLowerCase();
                const itemCity = safeGet(item, 'city', '').toLowerCase();
                
                return (
                  itemName.includes(city.toLowerCase()) ||
                  itemLocation.includes(city.toLowerCase()) ||
                  itemCity.includes(city.toLowerCase())
                );
              });
              
              const totalCount = matchingCities.reduce((sum, item) => sum + (item.count || 0), 0);
              
              return (
                <Chip
                  key={index}
                  label={`${city} ${totalCount > 0 ? `(${totalCount})` : ''}`}
                  onClick={() => {
                    if (matchingCities.length > 0) {
                      // Select the first matching city with highest count
                      const bestMatch = matchingCities.reduce((prev, current) => 
                        (prev.count || 0) > (current.count || 0) ? prev : current
                      );
                      handleLocationSelect(bestMatch);
                    } else {
                      handleLocationSelect({ 
                        name: city, 
                        type: 'city', 
                        count: 0,
                        fullLocation: city
                      });
                    }
                  }}
                  variant="outlined"
                  sx={{
                    borderColor: totalCount > 0 ? colors.secondary : '#ccc',
                    color: totalCount > 0 ? colors.secondary : '#666',
                    fontWeight: 'bold',
                    '&:hover': {
                      backgroundColor: totalCount > 0 ? colors.secondary : '#f0f0f0',
                      color: totalCount > 0 ? "#fff" : '#666'
                    }
                  }}
                />
              );
            })}
          </Box> */}
        </Box>

        {/* Property Type Filter */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: colors.primary }}>
            Property Type
          </Typography>
          <Chip
            label={selectedPropertyTypes.length > 0 ? `${selectedPropertyTypes.length} selected` : "Select Property Types"}
            onClick={() => setPropertyTypeDialogOpen(true)}
            variant="outlined"
            deleteIcon={<AddIcon />}
            onDelete={() => setPropertyTypeDialogOpen(true)}
            sx={{
              borderColor: colors.secondary,
              color: colors.secondary,
              '& .MuiChip-deleteIcon': {
                color: colors.secondary
              }
            }}
          />
          {selectedPropertyTypes.length > 0 && (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
              {selectedPropertyTypes.map((type, index) => (
                <Chip
                  key={index}
                  label={type}
                  onDelete={() => handlePropertyTypeSelect(type)}
                  sx={{
                    backgroundColor: colors.secondary,
                    color: "#fff",
                    '& .MuiChip-deleteIcon': {
                      color: "#fff"
                    }
                  }}
                />
              ))}
            </Box>
          )}
        </Box>

        {/* Tabs Section */}
        <Box sx={{ mb: 4, backgroundColor: '#fff', borderRadius: 2, overflow: 'hidden', border: '1px solid #e0e0e0' }}>
          <Typography variant="h6" sx={{ p: 2, fontWeight: 'bold', color: colors.primary, borderBottom: '1px solid #e0e0e0' }}>
            Looking For
          </Typography>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange} 
            variant="scrollable" 
            scrollButtons="auto"
            sx={{ 
              '& .MuiTab-root': { 
                fontSize: '0.8rem', 
                fontWeight: 'bold', 
                color: colors.primary, 
                minWidth: 'auto', 
                px: 2, 
                py: 1.5,
                '&.Mui-selected': { color: colors.secondary } 
              }, 
              '& .MuiTabs-indicator': { backgroundColor: colors.secondary } 
            }}
          >
            {filterTabs.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>
          <Box sx={{ p: 2, backgroundColor: '#f9f9f9', borderTop: '1px solid #e0e0e0' }}>
            <Typography variant="body2" sx={{ color: colors.primary, fontStyle: 'italic' }}>
              Selected: <strong>{filterTabs[activeTab]?.label || "None"}</strong>
            </Typography>
          </Box>
        </Box>

        {/* Stats Display */}
        {apiData.length > 0 && (
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#fff', borderRadius: 2, border: `1px solid ${colors.secondary}` }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: colors.primary, mb: 1 }}>
              Property Search Summary
            </Typography>
            <Typography variant="body2" sx={{ color: colors.primary, mb: 0.5 }}>
              • Total locations with properties: <strong>{apiData.length}</strong>
            </Typography>
            <Typography variant="body2" sx={{ color: colors.primary, mb: 0.5 }}>
              • Total properties available: <strong>{apiData.reduce((sum, item) => sum + (item.count || 0), 0)}</strong>
            </Typography>
            {nearbyLocations.length > 0 && (
              <Typography variant="body2" sx={{ color: colors.nearby, mb: 0.5 }}>
                • Nearby locations found: <strong>{nearbyLocations.length} within 5km</strong>
              </Typography>
            )}
            <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 1 }}>
              Data loaded from your property requests
            </Typography>
          </Box>
        )}

        {/* Apply Button */}
        <Button
          variant="contained"
          fullWidth
          onClick={handleApplyFilters}
          sx={{
            backgroundColor: colors.secondary,
            color: "#fff",
            py: 1.5,
            fontSize: '1rem',
            fontWeight: 'bold',
            borderRadius: 2,
            '&:hover': {
              backgroundColor: "#A52A2A"
            }
          }}
        >
          Apply
        </Button>
      </Box>

      {/* Location Dialog */}
      <Dialog open={locationDialogOpen} onClose={() => setLocationDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Add Locations</Typography>
            <IconButton onClick={() => setLocationDialogOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <FormControlLabel
            control={
              <Checkbox
                checked={useCurrentLocation}
                onChange={handleUseCurrentLocation}
                sx={{ color: colors.secondary }}
              />
            }
            label="Use my current location"
          />
          <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
            Selected Locations ({selectedLocations.length}/3)
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
            {selectedLocations.map((location, index) => {
              const name = safeGet(location, 'name');
              const count = safeGet(location, 'count', 0);
              
              return (
                <Chip
                  key={index}
                  label={`${name} ${count > 0 ? `(${count})` : ''}`}
                  onDelete={() => handleLocationRemove(location)}
                  sx={{
                    backgroundColor: colors.secondary,
                    color: "#fff",
                    '& .MuiChip-deleteIcon': {
                      color: "#fff"
                    }
                  }}
                />
              );
            })}
          </Box>
          {/* <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
            Popular Cities in India
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {popularCities.map((city, index) => {
              const matchingCities = apiData.filter(item => {
                const itemName = safeGet(item, 'name', '').toLowerCase();
                const itemLocation = safeGet(item, 'fullLocation', '').toLowerCase();
                return itemName.includes(city.toLowerCase()) || itemLocation.includes(city.toLowerCase());
              });
              
              const totalCount = matchingCities.reduce((sum, item) => sum + (item.count || 0), 0);
              
              return (
                <Chip
                  key={index}
                  label={`${city} ${totalCount > 0 ? `(${totalCount})` : ''}`}
                  onClick={() => {
                    if (matchingCities.length > 0) {
                      const bestMatch = matchingCities.reduce((prev, current) => 
                        (prev.count || 0) > (current.count || 0) ? prev : current
                      );
                      handleLocationSelect(bestMatch);
                    } else {
                      handleLocationSelect({ 
                        name: city, 
                        type: 'city', 
                        count: 0,
                        fullLocation: city
                      });
                    }
                  }}
                  variant="outlined"
                  sx={{
                    borderColor: totalCount > 0 ? colors.secondary : '#ccc',
                    color: totalCount > 0 ? colors.secondary : '#666',
                    '&:hover': {
                      backgroundColor: totalCount > 0 ? colors.secondary : '#f0f0f0',
                      color: totalCount > 0 ? "#fff" : '#666'
                    }
                  }}
                />
              );
            })}
          </Box> */}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setLocationDialogOpen(false)}
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: colors.secondary,
              color: "#fff",
              '&:hover': { backgroundColor: "#A52A2A" }
            }}
          >
            Done ({selectedLocations.length}/3 selected)
          </Button>
        </DialogActions>
      </Dialog>

      {/* Property Type Dialog */}
      <Dialog open={propertyTypeDialogOpen} onClose={() => setPropertyTypeDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Select Property Type</Typography>
            <IconButton onClick={() => setPropertyTypeDialogOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
            Select one or more property types
          </Typography>
          <List>
            {propertyTypes.map((type, index) => (
              <ListItem
                key={index}
                button
                onClick={() => handlePropertyTypeSelect(type)}
                sx={{
                  borderBottom: '1px solid #e0e0e0',
                  '&:last-child': { borderBottom: 'none' },
                  '&:hover': {
                    backgroundColor: "rgba(139, 115, 85, 0.1)"
                  }
                }}
              >
                <Checkbox
                  checked={selectedPropertyTypes.includes(type)}
                  sx={{ color: colors.secondary }}
                />
                <ListItemText 
                  primary={type} 
                  primaryTypographyProps={{ fontWeight: 'medium' }}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setPropertyTypeDialogOpen(false)}
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: colors.secondary,
              color: "#fff",
              '&:hover': { backgroundColor: "#A52A2A" }
            }}
          >
            Select ({selectedPropertyTypes.length} chosen)
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PropertySearchFilters;